import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "ol/ol.css";
import { Map, View } from "ol";
import Layer from "ol/layer/Layer";
import VectorLayer from "ol/layer/Vector";
import TileLayer from "ol/layer/Tile";
import LayerImage from "ol/layer/Image";
import LayerGroup from "ol/layer/Group";
import VectorSource from "ol/source/Vector";
import SourceImagestatic from "ol/source/ImageStatic";
import XYZ from "ol/source/XYZ";
import { defaults } from "ol/control";
import Attribution from "ol/control/Attribution";
import { transformExtent, fromLonLat, transform, toLonLat } from "ol/proj";
import Projection from "ol/proj/Projection";
// import Point from 'ol/geom/Point'
import { Circle, Point, LineString, GeometryCollection, Polygon } from "ol/geom";
import Style from "ol/style/Style";
import StyleIcon from "ol/style/Icon";
import StyleText from "ol/style/Text";
import StyleFill from "ol/style/Fill";
import StyleStroke from "ol/style/Stroke";
import StyleCircle from "ol/style/Circle";
import Feature from "ol/Feature";
import Collection from "ol/Collection";
import { GeoJSON } from "ol/format";
import Overlay from "ol/Overlay";
import { all } from "ol/loadingstrategy";
import { Draw, Snap, Modify, Select, DragBox, Translate } from "ol/interaction";
import { platformModifierKeyOnly, click } from "ol/events/condition";
import { getWidth, boundingExtent, getCenter, getHeight } from "ol/extent";
import * as olRender from "ol/render";
import axios from "axios";
import { asColorLike } from "ol/colorlike";
import { asString } from "ol/color";
// import { color as colorLike } from "ol/colorlike";
import { gaoDeToBaidu, bd_decrypt, loadScript, getImg, createBezierCurvePoints, getPointsBetweenLatLong } from "@/utils/utils";
import { mapState, mapGetters, mapMutations } from "vuex";
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";
import { getPan, getPinchRotate, getdragPan } from "@/view/map/js/common";
import cdata from "@/view/map/hdmconfigv2/common.js";
import { linedata, buttonForArea } from "@/view/map/hdmconfigv2/linedata.js";
let _ = require("lodash");
export default {
  name: "mapv2assembly",
  props: {
    jsonOption: {
      type: Object,
      default: {}
    },
    formatData: {
      type: Object,
      default: {}
    },
    cformUser: {
      type: Object,
      default: {}
    },
    formUserId: {
      type: Number,
      default: 0
    },
    id: {
      type: Number,
      default: 0
    },
    zoom: {
      type: Number,
      default: 5
    },
    minZoom: {
      type: Number,
      default: 0
    },
    maxZoom: {
      type: Number,
      default: 28
    },
    center: {
      type: Array,
      default: [116.3683244, 39.915085]
    },
    extent: {
      type: Array,
      default: [73.502355, 3.397162, 135.09567, 53.563269]
    },
    showgdtilelayer: {
      type: Boolean,
      default: false
    },
    showstaticlayer: {
      type: Boolean,
      default: false
    },
    staticimage: {
      type: String,
      default: ""
    },
    showgeojsonlayer: {
      type: Boolean,
      default: false
    },
    geojson: {
      type: Object,
      default: {}
    },
    drawelement: {
      type: Object,
      default: {}
    },
    showroutelayer: {
      type: Boolean,
      default: false
    },
    adcode: {
      type: String,
      default: "100000"
    },
    streetcode: {
      type: Array,
      default: []
    },
    pointlist: {
      type: Array,
      default: []
    },
    scale: {
      type: Boolean,
      default: false
    },
    rotate: {
      type: Boolean,
      default: false
    },
    translate: {
      type: Boolean,
      default: false
    },
    mapstyle: {
      type: Object,
      default: {}
    },
    culturallist: {
      type: Array,
      default: []
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    location: {
      type: Object,
      default: {}
    },
    rotation: {
      type: Number,
      default: 0
    },
    geoJsonData: {
      type: Object,
      default: {}
    },
    extentsForCity: {
      type: Object,
      default: {}
    },
    hightlightCity: {
      type: Object,
      default: {}
    },
    hightlightCityXunke: {
      type: Object,
      default: {}
    },
    lineJsonData: {
      type: Array,
      default: []
    },
    arrXiangyang: {
      type: Array,
      default: []
    },
    arrWuhan: {
      type: Array,
      default: []
    },
    arrYijingji: {
      type: Array,
      default: []
    }
  },
  components: {},
  meta: {
    title: "openlayermap组件"
  },
  data() {
    return {
      currentArea: {},
      mapcontainer: "",
      map: "",
      iconSource: "",
      iconLayer: [],
      style: {},
      cfeature: null,
      timer: null,
      defaultZoom: 0,
      moveendflag: true,
      drawflag: false,
      drawSource: "",
      drawLayer: [],
      drawsketch: "",
      drawinter: "",
      snapinter: "",
      modifyinter: "",
      helpTooltip: "",
      helpTooltipElement: "",
      deleteflag: false,
      selectinter: "",
      selectedFeatures: [],
      dragboxinter: "",
      drawstyle: {
        color: "rgba(0,0,0,0.5)",
        width: 1,
        lineDash: [2, 2]
      },
      drawtextflag: false,
      drawtextsingleflag: false,
      translateinter: "",
      isnotclick: false,
      currentTextstyle: {
        align: 0,
        // 排列方式 0纵向 1横向
        fontSize: 12,
        color1: "rgba(0, 0, 0, 1)",
        color2: "rgba(123, 33, 33, 1)"
      },
      defaulticon: "https://p.ananas.chaoxing.com/star3/origin/6e34ee5cc29e45f92fc9347bf35febfb.png",
      overlay: "undefined",
      findex: 0,
      CircleRadius: 5,
      lightIcon: [require("@/assets/map/138053/color1.gif"), require("@/assets/map/138053/color2.gif"), require("@/assets/map/138053/color3.gif"), require("@/assets/map/26091/xk.png"), require("@/assets/map/26091/xxhx.png")],
      //   customMapHubeihoverImg:[
      //     { fid: 26091, code: 420300, image:  require('@/assets/map/26091/shiyanshi.png') },
      // { fid: 26091, code: 429021, image:  require('@/assets/map/26091/shennongjia.png') },
      // { fid: 26091, code: 420600, image: require('@/assets/map/26091/xiangyang.png') },
      // { fid: 26091, code: 421300, image:  require('@/assets/map/26091/suzhoushi.png') },
      //   ],
      hoverImg: "",
      hoverImgList: [],
      routeSource: "",
      routeLayer: [],
      locationSource: "",
      locationLayer: [],
      locationicon: "https://p.ananas.chaoxing.com/star3/origin/8077173b8e82056110d8b5ea170d68c4.png",
      animating: false,
      movedefaulticon: "https://p.ananas.chaoxing.com/star3/origin/da0e3c42e5eca5562aeadbbe88bf1def.png",
      moveicon: "https://p.ananas.chaoxing.com/star3/origin/da0e3c42e5eca5562aeadbbe88bf1def.png",
      nowDate: "",
      moveprogress: "",
      geoMarker: "",
      jsonSource: "",
      routeData: [],
      selectIndex: "",
      selectCoords: [],
      selectcurveCoords: [],
      routeStyle: "",
      curvetools: null,
      modifySource: "",
      curverouteCoords: [],
      iseditpoint: false,
      selectArr: [],
      pointIcon: "",
      polygonfeature: "",
      linefeature: "",
      viewratio: 0,
      nmaxlen: 0,
      drift: 0,
      increase: 0,
      ih: 26,
      transdiffx: 0,
      transdiffy: 0,
      boxId: 0,
      areaList: [],
      starIcon: "",
      needAllFeture: [],
      dialogVisible: false,
      vectorSource: null,
      allGeometry: [],
      allLineInfo: [],
      currentSelectData: [],
      firstMove: true,
      firstMove2: true,
      boxLayers: [],
      shadowLayers: [],
      hoverLayers: [],
      isIndsq: false,
      currentFeatureId: 0
    };
  },
  created() {
    loadScript(`${process.env.NODE_ENV === "development" ? "/fileapi" : location.origin}/frontendTest1/openlayers/js/gifler.min.js`);
  },
  computed: {
    ...mapGetters(["mapv2info"]),
    mapv2infoViewchange() {
      const {
        zoom,
        minZoom,
        maxZoom,
        center,
        rotation
      } = this.mapv2info.view;
      return {
        zoom,
        minZoom,
        maxZoom,
        center,
        rotation
      };
    }
  },
  mounted() {
    //////////////////////////////console.log('geoJsonData')
    //////////////////////////////console.log(this.geoJsonData)
    // formUserId: 1516351940 为橙色     formUserId: 1516336824 为蓝色  formUserId:  1514653091 展示
    //////////////////////////////////console.log('this.formUserId')
    //////////////////////////////////console.log(this.formUserId)
    //////////////////////////////console.log('this.jsonOption',this.jsonOption)
    this.initMap();
    this.style = this.id === 0 ? this.mapv2info.style : this.mapstyle;
    //////////////////////////////////////////////console.log(`this.style`, this.style);
    if (this.style.routemoveicon !== undefined && this.style.routemoveicon.length > 0) this.moveicon = this.style.routemoveicon[0].fileUrl;
    this.hoverImgList = this.formUserId == 1516351940 ? cdata.maphoverimagesHubei : this.formUserId == 1516336824 ? cdata.maphoverimagesHubeiJiaohu : cdata.maphoverimagesHubeiJiaohu;
    //////////////////////////////////////////////console.log('this.hoverImgList',this.hoverImgList)

    if (this.$route.query.edit && this.formUserId != 1514653091) {
      this.iseditpoint = true;
      // this.dialogVisible=true
    }
    // if(this.formUserId==1514653091){
    //   this.iseditpoint = true
    // }
    this.updateMap();
    // this.zoomMap(0.5)
    // if(window.innerWidth<=1500){
    //   this.zoomMap(0.6)
    // }else{
    //   this.zoomMap(1)
    // }
    // window.addEventListener('resize', ()=>{
    //   this.updateMap()
    //   if(window.innerWidth<=1500){
    //   this.zoomMap(0.6)
    // }else{
    //   this.zoomMap(1)
    // }
    // });
  },
  watch: {
    // selectArr:{
    //   handler (val) {

    //     ////////////////////console.log('selectArr',selectArr)
    //   },
    //   deep: true
    // },
    isIndsq: {
      handler(val) {
        ////console.log("isIndsq", val);
      },
      deep: true
    },
    pointlist: {
      handler(val) {
        console.log(`pointlist`);
        console.log(val);
        // val.forEach((e) => {
        //   if (e.itemformdata.place_name == "武汉设计工程学院") {
        //     console.log("e", e);
        //     e.itemformdata.map_coordinates = "20,30.584355";
        //   }
        // });
        this.createPoint(val);
        // 暂时注释1105
        // if(this.formUserId==1514653091){
        //   this.drawAreaList()
        // }
        this.drawAreaList(val);
        if (this.iseditpoint) this.addDrawInteractions1();
      },
      deep: true
    },
    showgdtilelayer: {
      handler(val) {
        //////////////////////////////////console.log(`showgdtilelayer`, val);
        this.map.getLayers().getArray().forEach(item => {
          if (item.className_ === "tile") item.setVisible(val);
        });
      },
      deep: true
    },
    staticimage: {
      handler(val) {
        //////////////////////////////////console.log(`staticimage`, val);
        if (val) {
          this.map.getLayers().getArray().forEach(item => {
            if (item.className_ === "static") {
              item.setVisible(true);
              const imageExtent = transformExtent(this.extent, "EPSG:4326", "EPSG:3857");
              const imageProjection = new Projection({
                code: "xkcd-image",
                units: "pixels",
                extent: imageExtent
              });
              item.setSource(new SourceImagestatic({
                url: val,
                projection: imageProjection,
                imageExtent: imageExtent
              }));
            }
            if (item.className_ === "json") item.setOpacity(0);
          });
        }
      },
      deep: true
    },
    culturallist: {
      handler(val) {
        //////////////////////////////////console.log(`culturallist`);
        //////////////////////////////////console.log(val);
        this.createculturalPoint(val);
      },
      deep: true
    },
    showroutelayer: {
      handler(val) {
        //////////////////////////////////console.log(`showgdtilelayer`, val);
        this.map.getLayers().getArray().forEach(item => {
          if (item.className_ === "route") item.setVisible(val);
        });
      },
      deep: true
    },
    location: {
      handler(val) {
        this.loadLocation(val);
      },
      deep: true
    },
    "mapv2info.style.pointpic": {
      handler(val) {
        //////////////////////////////////console.log(`mapv2info.style.pointpic`, val);
        this.iconSource.clear();
        this.createPoint(this.pointlist);
        if (this.mapv2info.form.cTemplateScore === 1) this.createculturalPoint(this.culturallist);
      },
      deep: true
    },
    "mapv2info.style.pointicon": {
      handler(val) {
        //////////////////////////////////console.log(`mapv2info.style.pointicon`, val);
        this.iconSource.clear();
        this.createPoint(this.pointlist);
      },
      deep: true
    },
    "mapv2info.style.pointtext": {
      handler(val) {
        //////////////////////////////////console.log(`mapv2info.style.pointtext`, val);
        this.iconSource.clear();
        this.createPoint(this.pointlist);
      },
      deep: true
    },
    "mapv2info.style.pointStyleIndex"(val) {
      //////////////////////////////////console.log(`mapv2info.style.pointStyleIndex`, val);
      this.iconSource.clear();
      this.createPoint(this.pointlist);
    },
    "mapv2info.style.showroute"(val) {
      //////////////////////////////////console.log(`mapv2info.style.showroute`, val);
      this.map.getLayers().getArray().forEach(item => {
        if (item.className_ === "route") item.setVisible(val === 1 ? true : false);
      });
      this.createRoute(this.mapv2info.routeSources);
    },
    "mapv2info.style.routemoveicon": {
      handler(val) {
        //////////////////////////////////console.log(`mapv2info.style.routemoveicon`, val);
        this.moveicon = val.length > 0 ? val[0].fileUrl : this.movedefaulticon;
      },
      deep: true
    },
    mapv2infoViewchange() {
      this.updateMap();
    },
    "mapv2info.view.scale"(val) {
      //////////////////////////////////console.log(`mapv2info.view.scale`, val);
      val ? getPan(this.map) : getPan(this.map, true);
    },
    "mapv2info.view.rotate"(val) {
      //////////////////////////////////console.log(`mapv2info.view.rotate`, val);
      val ? getPinchRotate(this.map) : getPinchRotate(this.map, true);
    },
    "mapv2info.view.translate"(val) {
      //////////////////////////////////console.log(`mapv2info.view.translate`, val);
      val ? getdragPan(this.map) : getdragPan(this.map, true);
    },
    "mapv2info.drawlayer.toolsIndex"(val) {
      // 操作类型 0绘制文字 1绘制线 2删除 3框选 4平移
      //////////////////////////////////console.log(`mapv2info.drawlayer.toolsIndex`, val);
      if (val === "") return;
      this.changeToolHandle(val);
    },
    "mapv2info.drawlayer.linestyle"(val) {
      //////////////////////////////////console.log('mapv2info.drawlayer.linestyle')
      //////////////////////////////////console.log(val)
      if (val) {
        this.drawstyle = val;
        this.drawSource.getFeatures().forEach(feature => {
          if (feature.getGeometry() && feature.getGeometry().getType() === "LineString") feature.setStyle(new Style({
            stroke: new StyleStroke(val)
          }));
          if (feature.getGeometry() && feature.getGeometry().getType() === "Circle") feature.setStyle(new Style({
            fill: new StyleFill({
              color: val.color
            }),
            stroke: new StyleStroke({
              color: val.color,
              width: this.CircleRadius
            })
          }));
        });
      }
    },
    "mapv2info.drawlayer.currentList"(val) {
      //////////////////////////////////console.log('mapv2info.drawlayer.currentList')
      this.createText(val, "currentList");
    },
    "mapv2info.drawlayer.drawtextblocksum"(val) {
      //////////////////////////////////console.log('mapv2info.drawlayer.drawtextblocksum', val)
      this.createText(val, "drawtextblocksum");
    },
    "mapv2info.drawlayer.showtranfer"(val) {
      //////////////////////////////////console.log('mapv2info.drawlayer.showtranfer', val)
      if (!val && this.mapv2info.drawlayer.dtext) this.showtexthelp();
    },
    "mapv2info.drawlayer.currentTextstyle": {
      handler(val) {
        //////////////////////////////////console.log('mapv2info.drawlayer.currentTextstyle')
        //////////////////////////////////console.log(val)
        if (val) {
          this.currentTextstyle = val;
          this.createText(this.mapv2info.drawlayer.currentList, "currentList");
        }
      },
      deep: true
    },
    "mapv2info.routeSources": {
      handler(val) {
        if (!this.showroutelayer) return;
        this.createRoute(val);
      },
      deep: true
    }
  },
  methods: {
    lerpColor(startColor, endColor, stepCount) {
      // 解析颜色值为RGB对象
      function parseColor(color) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
        return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        } : null;
      }

      // 将RGB对象转换回十六进制字符串
      function rgbToHex({
        r,
        g,
        b
      }) {
        return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
      }
      const startRGB = parseColor(startColor);
      const endRGB = parseColor(endColor);
      const gradientColors = [];
      for (let i = 0; i <= stepCount; i++) {
        const ratio = i / stepCount;
        const newR = Math.round(startRGB.r + ratio * (endRGB.r - startRGB.r));
        const newG = Math.round(startRGB.g + ratio * (endRGB.g - startRGB.g));
        const newB = Math.round(startRGB.b + ratio * (endRGB.b - startRGB.b));
        gradientColors.push(rgbToHex({
          r: newR,
          g: newG,
          b: newB
        }));
      }
      return gradientColors;
    },
    // changeShadow(item, extent) {
    //   if (this.formUserId == 1516351940) {
    //     if (item.renderer_ && item.renderer_.context) {
    //       item.renderer_.context.shadowOffsetY = 10;

    //       item.renderer_.context.shadowColor = "#F7B74B";
    //     }
    //   } else if (this.formUserId == 1516336824) {
    //     if (item.renderer_ && item.renderer_.context) {
    //       item.renderer_.context.shadowOffsetY = 10;
    //       item.renderer_.context.shadowColor = "#09B8CB";
    //     }
    //   } else {
    //     if (item.renderer_ && item.renderer_.context) {
    //       item.renderer_.context.shadowOffsetY = 10;
    //       item.renderer_.context.shadowColor = "#09B8CB";
    //     }
    //   }
    // },
    changeShadow(feature, extent, current) {
      // ////console.log("feature1", feature);
      const upextent = extent.map((item, index) => {
        return index === 1 || index === 3 ? item + 20000 : item;
      });
      const gradient1 = this.formUserId == 1516351940 ? this.lerpColor("#CD7843", "#F7B74B", 20) : this.lerpColor("#2B97C6", "#09B8CB", 20);
      const shadowSource = new VectorSource({
        features: [feature]
      });
      // //////console.log("gradient1", gradient1);
      const HoverShadowLayer = new VectorLayer({
        source: new VectorSource(),
        opacity: 1,
        className: "hovershadow",
        zIndex: 5,
        visible: true
      });
      let that = this;
      HoverShadowLayer.setSource(shadowSource);
      HoverShadowLayer.setStyle(new Style({
        renderer(coordinate, state) {
          // //////console.log("coordinate", coordinate);
          // //////console.log("state", state);
          coordinate.forEach(item => {
            let arr = item[0];
            const ctx = state.context;
            gradient1.forEach((color, index) => {
              that.addOutlineShadow(ctx, {
                coodArr: arr,
                fillStyle: color,
                y: -(index - 2)
              });
            });
          });
        }
      }));
      const HoverImageLayer = new LayerImage({
        source: new SourceImagestatic({
          url: current.image ? current.image : current.url,
          projection: "EPSG:3857",
          imageExtent: upextent
        }),
        opacity: 1,
        className: "hover",
        zIndex: 7,
        visible: true
      });
      this.map.addLayer(HoverImageLayer);
      this.map.addLayer(HoverShadowLayer);
      // ////console.log("HoverShadowLayer", HoverShadowLayer);
      this.shadowLayers.push(HoverShadowLayer);
      this.hoverLayers.push(HoverImageLayer);
    },
    changeShadow1(features = [], extent, current, dxq) {
      features.forEach(feature => {
        let extent = feature.values_.geometry.extent_;
        const upextent = extent.map((item, index) => {
          return index === 1 || index === 3 ? item + 20000 : item;
        });
        const gradient1 = this.formUserId == 1516351940 ? this.lerpColor("#CD7843", "#F7B74B", 20) : this.lerpColor("#2B97C6", "#09B8CB", 20);
        const shadowSource = new VectorSource({
          features: [feature]
        });
        // //////console.log("gradient1", gradient1);
        const HoverShadowLayer = new VectorLayer({
          source: new VectorSource(),
          opacity: 0,
          className: "hovershadow",
          zIndex: 4,
          visible: true
        });
        let that = this;
        HoverShadowLayer.setSource(shadowSource);
        HoverShadowLayer.setStyle(new Style({
          renderer(coordinate, state) {
            // //////console.log("coordinate", coordinate);
            // //////console.log("state", state);
            coordinate.forEach(item => {
              let arr = item[0];
              const ctx = state.context;
              gradient1.forEach((color, index) => {
                that.addOutlineShadow(ctx, {
                  coodArr: arr,
                  fillStyle: color,
                  y: -(index - 2)
                });
              });
            });
          }
        }));
        this.map.addLayer(HoverShadowLayer);
        ////console.log("HoverShadowLayer", HoverShadowLayer);
        this.shadowLayers.push(HoverShadowLayer);
      });
      // const upextent = extent.map((item, index) => {
      //   return index === 1 || index === 3 ? item + 20000 : item;
      // });
      // const HoverImageLayer = new LayerImage({
      //   source: new SourceImagestatic({
      //     url: current.image ? current.image : current.url,
      //     projection: "EPSG:3857",
      //     imageExtent: upextent,
      //   }),
      //   opacity: 0,
      //   className: "hover",
      //   zIndex: 7,
      //   visible: true,
      // });
      // this.map.addLayer(HoverImageLayer);
      // this.hoverLayers.push(HoverImageLayer);
      // HoverImageLayer.setOpacity(1);
      this.shadowLayers.forEach(e => {
        e.setOpacity(1);
      });
    },
    changeShadow2(feature, extent, current) {
      // ////console.log("feature", feature);
      const upextent = extent.map((item, index) => {
        return index === 1 || index === 3 ? item + 20000 : item;
      });
      let that = this;
      const gradient1 = this.formUserId == 1516351940 ? this.lerpColor("#CD7843", "#F7B74B", 20) : this.lerpColor("#2B97C6", "#09B8CB", 20);
      const HoverImageLayer = new LayerImage({
        source: new SourceImagestatic({
          url: current.image ? current.image : current.url,
          projection: "EPSG:3857",
          imageExtent: upextent
        }),
        opacity: 1,
        className: "hover",
        zIndex: 7,
        visible: true
      });
      // const shadowSource = new VectorSource({ features: [HoverImageLayer] });
      // const HoverShadowLayer = new VectorLayer({
      //   source: new VectorSource(),
      //   opacity: 1,
      //   className: "hovershadow",
      //   zIndex: 5,
      //   visible: true,
      // });
      // HoverShadowLayer.setSource(shadowSource);
      // HoverShadowLayer.setStyle(
      //   new Style({
      //     renderer(coordinate, state) {
      //       // //////console.log("coordinate", coordinate);
      //       // //////console.log("state", state);
      //       coordinate.forEach((item) => {
      //         let arr = item[0];
      //         const ctx = state.context;
      //         gradient1.forEach((color, index) => {
      //           that.addOutlineShadow(ctx, {
      //             coodArr: arr,
      //             fillStyle: color,
      //             y: -(index - 2),
      //           });
      //         });
      //       });
      //     },
      //   })
      // );
      // this.map.addLayer(HoverShadowLayer);

      this.map.addLayer(HoverImageLayer);
      // ////console.log("HoverShadowLayer", HoverShadowLayer);
      // this.shadowLayers.push(HoverShadowLayer);
      this.hoverLayers.push(HoverImageLayer);
    },
    changeFontStyle(feature) {
      // 获取feature的范围
      const extent = feature.getGeometry().getExtent();
      const [minX, minY, maxX, maxY] = extent;
      // //////console.log("extent", extent);
      // //////console.log("feature", feature);

      // 定义固定的左侧偏移量
      const fixedLeftOffset = minX + 38000; // 这是所有图层共用的左侧偏移

      // 定义每个图层的不同宽度扩展
      const widthExtensions = [{
        name: "outer",
        value: 10000 * 12
      }
      // { name: "inner", value: 0 }, // 内层不扩展
      ];
      let len = feature.values_.name.length + feature.getStyle().length;
      // 创建并添加所有图层
      widthExtensions.forEach(extension => {
        const leftX = fixedLeftOffset - extension.value;
        const rightX = fixedLeftOffset + (maxX - minX) + 10000 * len;

        // 创建一个多边形以模拟边框偏移效果
        const fillPolygonCoords = [[leftX, minY - 12000],
        // 底部左
        [rightX, minY - 12000],
        // 底部右
        [rightX, maxY + 12000],
        // 顶部右
        [leftX, maxY + 12000],
        // 顶部左
        [leftX, minY - 12000] // 关闭路径
        ];
        const fillPolygon = new Polygon([fillPolygonCoords]);
        const fillFeature = new Feature({
          geometry: fillPolygon
        });

        // 设置填充样式
        const fillStyle = new Style({
          fill: new StyleFill({
            color: "rgba(235, 243, 255, 1)"
          }),
          stroke: new StyleStroke({
            color: "rgba(235, 243, 255, 1)",
            width: 2
          })
        });
        fillFeature.setStyle(fillStyle);

        // 创建新的矢量数据源用于存放填充多边形
        const fillVectorSource = new VectorSource();
        fillVectorSource.addFeature(fillFeature);

        // 创建矢量图层用于显示填充多边形
        const fillVectorLayer = new VectorLayer({
          source: fillVectorSource,
          zIndex: extension.name === "outer" ? -2 : -1 // 确保外层在内层下方
        });
        // 将填充图层添加到地图并保存引用
        this.map.addLayer(fillVectorLayer);
        this.boxLayers.push(fillVectorLayer);
      });
    },
    changeFontStyle2(feature) {
      // 获取feature的范围
      const extent = feature.getGeometry().getExtent();
      const [minX, minY, maxX, maxY] = extent;
      // //////console.log("extent", extent);
      // //////console.log("feature", feature);

      // 定义固定的左侧偏移量
      const fixedLeftOffset = minX + 38000; // 这是所有图层共用的左侧偏移

      // 定义每个图层的不同宽度扩展
      const widthExtensions = [{
        name: "outer",
        value: 10000 * 12
      }
      // { name: "inner", value: 0 }, // 内层不扩展
      ];
      // let len = feature.values_.name.length + feature.getStyle().length;
      // 创建并添加所有图层
      widthExtensions.forEach(extension => {
        const leftX = fixedLeftOffset - extension.value;
        const rightX = fixedLeftOffset + (maxX - minX) + 110000;

        // 创建一个多边形以模拟边框偏移效果
        const fillPolygonCoords = [[leftX, minY - 12000],
        // 底部左
        [rightX, minY - 12000],
        // 底部右
        [rightX, maxY + 12000],
        // 顶部右
        [leftX, maxY + 12000],
        // 顶部左
        [leftX, minY - 12000] // 关闭路径
        ];
        const fillPolygon = new Polygon([fillPolygonCoords]);
        const fillFeature = new Feature({
          geometry: fillPolygon
        });

        // 设置填充样式
        const fillStyle = new Style({
          fill: new StyleFill({
            color: "rgba(235, 243, 255, 1)"
          }),
          stroke: new StyleStroke({
            color: "rgba(235, 243, 255, 1)",
            width: 2
          })
        });
        fillFeature.setStyle(fillStyle);

        // 创建新的矢量数据源用于存放填充多边形
        const fillVectorSource = new VectorSource();
        fillVectorSource.addFeature(fillFeature);

        // 创建矢量图层用于显示填充多边形
        const fillVectorLayer = new VectorLayer({
          source: fillVectorSource,
          zIndex: extension.name === "outer" ? -2 : -1 // 确保外层在内层下方
        });
        // 将填充图层添加到地图并保存引用
        this.map.addLayer(fillVectorLayer);
        this.boxLayers.push(fillVectorLayer);
      });
    },
    zoomMap(scaleFactor) {
      const currentZoom = this.map.getView().getZoom();
      const newZoom = currentZoom + Math.log(scaleFactor) / Math.LN2; // 使用对数换算缩放级别
      this.map.getView().setZoom(newZoom);
      //////////////console.log(this.map.getView());
      //////////////console.log(currentZoom);
      //////////////console.log(newZoom);
      //////////////console.log(7788103);
    },
    onlyAreaList(val) {
      const filteredArray = val.filter(item => {
        // 判断 data 是否为空，这里定义了空的几种情况：null, undefined, 空字符串, 空数组
        const isEmpty = item.data === null || item.data === undefined || item.data === "" || Array.isArray(item.data) && item.data.length === 0;

        // 返回非空的对象
        return !isEmpty;
      });
      return filteredArray;
    },
    addDrawInteractions1() {
      this.addselectInteraction();
      this.adddragboxInteraction();
    },
    ...mapMutations(["SET_MAPDRAWLAYERITEM", "SET_MAPROUTECURVE"]),
    quitPointHandle() {
      // this.dialogVisible = false
    },
    confirmPointHandle() {
      // this.dialogVisible = false
      this.jsonOption.drawlayer.drawarea = this.onlyAreaList(this.areaList);
      //////////////////////////////console.log('this.jsonOption.drawlayer')
      //////////////////////////////console.log(this.jsonOption)
      let richtext = `<p element-id=\"init\" style="display: none;">${JSON.stringify(this.jsonOption)}</p>`;
      let dataList = [];
      dataList.push({
        alias: "onlyid",
        compt: "autonumber",
        values: [{
          val: this.formatData.onlyid
        }]
      });
      dataList.push({
        alias: "title",
        compt: "editinput",
        values: [{
          val: this.formatData.title
        }]
      });
      dataList.push({
        alias: "jsontxt",
        compt: "richtext",
        values: [{
          val: richtext
        }]
      });
      // //////////////////////////////////console.log(`dataList`, dataList)
      // return
      this.$api.editForm(this.$route.query.fid, this.$route.query.formUserId, encodeURI(JSON.stringify(dataList)), this.cformUser.formId).then(res => {
        ElMessage({
          message: "保存成功",
          type: "success"
        });
      });
    },
    /**
     * 初始化地图
     */
    initMap(drawjson) {
      //////////////////////////////////////////////console.log('初始化地图', this.zoom);
      this.defaultZoom = Math.round(this.zoom);
      const defaultlayer = this.getTileLayer();
      const staticImageLayer = this.getstaticImageLayer();
      //console.log("staticImageLayer", staticImageLayer);
      const jsonlayer = this.getjsonlayer();
      const hoverLayer = this.gethoverLayer();

      // 地图地点图层
      this.iconSource = new VectorSource();
      this.iconLayer = new VectorLayer({
        source: this.iconSource,
        className: "icon",
        zIndex: 6
      });

      // 地图路线图层
      this.routeSource = new VectorSource();
      this.routeLayer = new VectorLayer({
        source: this.routeSource,
        className: "route",
        zIndex: 5
      });
      // 绘制图层
      this.drawLayer = this.getDrawLayer(drawjson);
      this.drawSource.on("change", evt => {
        this.drawSourceChange(evt);
      });

      // 地图地点图层
      this.locationSource = new VectorSource();
      this.locationLayer = new VectorLayer({
        source: this.locationSource,
        className: "location",
        zIndex: 8
      });
      const wh = [12709327.41537128, 3547968.6618375056, 12863907.95872908, 3572831.348258046];
      const layerExtentWh = [wh[0], wh[1], wh[2], wh[3]];
      const imageLayerWh = new LayerImage({
        source: new SourceImagestatic({
          url: require("@/assets/map/26091/dushiquan/wuhan.png"),
          projection: "EPSG:3857",
          // 地图投影
          imageExtent: layerExtentWh
        }),
        opacity: 1,
        className: "static",
        zIndex: 10
      });
      const xy = [12247747.750939246, 3567426.4164274936, 12440162.693020985, 3593370.0892141443];
      const layerExtentXy = [xy[0], xy[1], xy[2], xy[3]];
      const imageLayerXy = new LayerImage({
        source: new SourceImagestatic({
          url: require("@/assets/map/26091/dushiquan/yjj.png"),
          projection: "EPSG:3857",
          // 地图投影
          imageExtent: layerExtentXy
        }),
        opacity: 1,
        className: "static",
        zIndex: 10
      });
      const yjj = [12329040.347432509, 3782542.7032834725, 12485783.528526135, 3807405.389704013];
      const layerExtentyjj = [yjj[0], yjj[1], yjj[2], yjj[3]];
      const imageLayeryjj = new LayerImage({
        source: new SourceImagestatic({
          url: require("@/assets/map/26091/dushiquan/xiangyang.png"),
          projection: "EPSG:3857",
          // 地图投影
          imageExtent: layerExtentyjj
        }),
        opacity: 1,
        className: "static",
        zIndex: 10
      });
      this.mapcontainer = this.$refs[`map${this.id}`];

      // let baseVector = new VectorLayer({
      //   source: new VectorSource({
      //     format: new GeoJSON(),
      //     url: require("@/assets/map/26091/420000.json"),
      //   }),
      //   style: new Style({
      //     fill: new StyleFill({
      //       color: "rgba(242, 176, 75, 0.5)", // 半透明的白色
      //       // color: "rgba(255, 255, 255, 1)", // 黄色
      //     }),
      //     // 设置要素的边框样式
      //     stroke: new StyleStroke({
      //       color: "rgba(255, 255, 255, 1)", // 黄色
      //       width: 3,
      //     }),
      //   }),
      //   opacity: 0,
      //   visible: true,
      //   className: "fulljson",
      //   zIndex: 3,
      // });
      // //console.log("baseVector", baseVector);
      let that = this;
      const gradient = this.formUserId == 1516351940 ? this.lerpColor("#A2393B", "#CD7843", 20) : this.lerpColor("#4D75C1", "#2B97C6", 20);
      let apiurl = `${process.env.NODE_ENV === "development" ? "/fileapi" : location.origin}/frontendTest1/openlayers/data/`;
      let baseShadowVector = new VectorLayer({
        source: new VectorSource({
          format: new GeoJSON(),
          url: `${apiurl}420000.json`
        }),
        style: new Style({
          renderer(coordinate, state) {
            //console.log("coordinate", coordinate);
            //console.log("state", state);
            coordinate.forEach(item => {
              let arr = item[0];
              const ctx = state.context;
              gradient.forEach((color, index) => {
                // //console.log("color", color);
                that.addOutlineShadow(ctx, {
                  coodArr: arr,
                  fillStyle: color,
                  y: -index + 20
                  // y: -(index - 2),
                });
              });
            });
          }
        }),
        opacity: 1,
        className: "singlejson",
        zIndex: 2
      });
      // //console.log("baseShadowVector", baseShadowVector);
      // let x = require("@/assets/map/26091/420000.json");
      // //console.log("x", x);
      //////////////////////////////////////////////console.log(`this.rotation`, this.rotation)
      this.map = new Map({
        layers: [defaultlayer, staticImageLayer,
        // baseVector,
        baseShadowVector, jsonlayer, imageLayerWh, imageLayerXy, imageLayeryjj, hoverLayer, this.routeLayer, this.iconLayer, this.drawLayer, this.locationLayer],
        target: this.mapcontainer,
        view: new View({
          center: transform(this.center, "EPSG:4326", "EPSG:3857"),
          minZoom: this.minZoom,
          maxZoom: this.maxZoom,
          zoom: this.zoom,
          rotation: this.rotation
        }),
        controls: defaults({
          attribution: false
        })
      });
      //console.log("this.map1111", this.map.getLayers().getArray());
      // //console.log("staticImageLayer", staticImageLayer);
      // //console.log("staticImageLayer", staticImageLayer.renderer_);
      this.scale ? getPan(this.map) : getPan(this.map, true);
      this.rotate ? getPinchRotate(this.map) : getPinchRotate(this.map, true);
      this.translate ? getdragPan(this.map) : getdragPan(this.map, true);
      this.map.on("singleclick", this.singleclick);
      this.map.on("click", this.markerclick);
      this.map.on("pointermove", this.markermove);
      //console.log("this.map", this.map);
      this.map.getLayers().getArray().forEach(item => {
        if (item.className_ === "tile") item.setVisible(this.showgdtilelayer);
        if (item.className_ === "static") item.setVisible(this.showstaticlayer);
        if (item.className_ === "json") {
          item.setVisible(this.showgeojsonlayer);
          // 这里控制位置标定线的显示与隐藏
          if (this.staticimage) item.setOpacity(0);
        }
        if (item.className_ === "hoverimg") item.setVisible(false);
        if (item.className_ === "route") item.setVisible(this.showroutelayer);
      });
      this.map.on("moveend", this.markermoveend);
      //////////////////////console.log('len111',this.drawSource.getFeatures().filter(e=>e&&e.getStyle()==null))

      this.drawfitHandle();
      this.initMapLine();
    },
    initMapLine() {
      const drawSource = new VectorSource();
      this.geoJsonData.features.forEach(feature => {
        if (feature.geometry.type === "LineString") {
          const lineFeature = new Feature(new LineString(feature.geometry.coordinates));
          // this.drawSource.addFeature(lineFeature);

          drawSource.addFeature(lineFeature);
          const offsetY = -2200; // 向下平移的距离（单位取决于你的投影和缩放级别）
          ////////console.log("LineString", lineFeature);
          // 蓝色条线
          console.log("lineFeature", lineFeature);
          drawSource.getFeatures().forEach(feature => {
            if (feature.getGeometry().getType() === "LineString") {
              feature.setStyle(new Style({
                fill: new StyleFill({
                  color: "rgba(0, 56, 238, 0.05)"
                }),
                stroke: new StyleStroke({
                  color: "rgba(0, 56, 238, 0.05)",
                  width: 4
                })
              }));
              const coordinatess = lineFeature.getGeometry().getCoordinates();
              const newCoordinates = coordinatess.map(coord => [coord[0], coord[1] + offsetY]);
              lineFeature.getGeometry().setCoordinates(newCoordinates);
            }
          });

          // 提取线段端点并创建点特征
          const coordinates = lineFeature.getGeometry().getCoordinates();
          const startPoint = new Feature(new Point(coordinates[0]));
          const endPoint = new Feature(new Point(coordinates[coordinates.length - 1]));

          // 应用图标样式到点特征
          const iconStyle = new Style({
            image: new StyleIcon({
              src: require("@/assets/map/138053/circle.png"),
              anchor: [0.5, 0.5],
              // 锚点设置，根据图标调整
              anchorXUnits: "fraction",
              anchorYUnits: "fraction",
              scale: 0.25
            })
          });
          startPoint.setStyle(iconStyle);
          endPoint.setStyle(iconStyle);
          // [startPoint, endPoint].forEach(feature => {

          //   //////////////////////////console.log('feature111',feature)
          //   // 添加鼠标悬停效果
          //   feature.on('pointermove', () => {
          //     //////////////////////////console.log(123)
          //   });

          //   feature.on('pointermove', () => {
          //     //////////////////////////console.log(456)
          //   });
          // });
          // this.drawSource.addFeature(startPoint);
          // this.drawSource.addFeature(endPoint);
          drawSource.addFeature(startPoint);
          drawSource.addFeature(endPoint);
          var drawLayer = new VectorLayer({
            source: drawSource
          });
          // 设置较高的 zIndex 值，使其在其他图层之上显示
          drawLayer.setZIndex(15);
          this.map.addLayer(drawLayer);
        }
      });
      this.allLineInfo = [];
      this.drawSource.getFeatures().filter(e => e && e.getStyle() == null).forEach(element => {
        this.allLineInfo.push({
          lid: element.ol_uid * 1 + 4 + "",
          id: element.ol_uid,
          rid: element.ol_uid * 1 + 2 + ""
        });
      });
      this.drawSource.getFeatures().filter(e => e && e.getStyle() == null).forEach(e => {
        e.setStyle(new Style({
          stroke: new StyleStroke({
            color: "rgba(0, 56, 238, 0.35)",
            width: 4
          })
        }));
      });
    },
    addOutlineShadow(ctx, option) {
      // //////console.log(`option.strokeStyle`, option.strokeStyle)
      // 设置属性控制图形的外观
      ctx.fillStyle = option.fillStyle || "transparent";
      ctx.strokeStyle = option.strokeStyle || "transparent";
      ctx.beginPath();
      let arr = option.coodArr || [];
      for (let i = 0; i < arr.length; i++) {
        const data = arr[i];
        if (i === 0) {
          ctx.moveTo(data[0] - 0, data[1] + option.y);
        } else {
          ctx.lineTo(data[0] - 0, data[1] + option.y);
        }
      }
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
    },
    /**
     * 非1920*1080分辨率且绘制图层有数据时 处理显示范围及位置
     */
    drawfitHandle() {
      ////////////////////////////////console.log('1111')
      if (document.body.clientWidth !== 1920 && this.drawSource !== "") {
        let widthflag = document.body.clientWidth <= 1440;
        let listpos = this.mapstyle.listpos;
        let mapPadding = [30, 30, 30, 30];
        let type = listpos.ptype.split("-");
        switch (type[0]) {
          case "left":
            mapPadding[3] = widthflag <= 1440 ? 430 : 530;
            break;
          case "right":
            mapPadding[1] = widthflag <= 1440 ? 430 : 530;
            break;
        }
        this.$nextTick(() => {
          this.map.getView().fit(this.drawSource.getExtent(), {
            size: this.map.getSize(),
            padding: mapPadding
          });
        });
      }
    },
    /**
     * 加载高德地图瓦片作为底图
     */
    getTileLayer() {
      return new TileLayer({
        source: new XYZ({
          url: "http://webrd03.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}"
        }),
        className: "tile",
        zIndex: 1
      });
    },
    /**
     * 加载静态图片
     */
    getstaticImageLayer() {
      //////////////////////////////////////////////console.log(`this.staticimage`, this.staticimage);
      // 假设你的图层边界在4326下是 [minx, miny, maxx, maxy]
      //////console.log(`this.extent`, this.extent);
      const layerExtentIn4326 = this.extent;
      // const layerExtentIn4326 = [
      //     108.38904993941489,
      //     28.908357621360693,
      //     116.12863907482017,
      //     33.287451223440925
      // ];
      // const layerExtentIn4326 = [
      //   108.37271539853077,
      //   28.891919914702427,
      //   116.1294366014692,
      //   33.29015874545334,
      // ];
      // 转换边界的对角点到3857坐标系
      const bottomLeftIn3857 = fromLonLat([layerExtentIn4326[0], layerExtentIn4326[1]]);
      const topRightIn3857 = fromLonLat([layerExtentIn4326[2], layerExtentIn4326[3]]);
      // 创建在3857坐标系下的边界（注意：extent 是 [minx, miny, maxx, maxy]）
      let layerExtentIn3857 = [bottomLeftIn3857[0], bottomLeftIn3857[1], topRightIn3857[0], topRightIn3857[1]];
      // layerExtentIn3857[1] = layerExtentIn3857[1] + 15000;
      // layerExtentIn3857[3] = layerExtentIn3857[3] + 15000;
      //console.log(`this.staticimage`, this.staticimage);
      //////console.log(`layerExtentIn3857`, layerExtentIn3857);
      // const gradient = this.lerpColor("#4D75C1", "#2B97C6", 20);
      // let baseShadowVector = new VectorLayer({
      //   source: new VectorSource({
      //     format: new GeoJSON(),
      //     url: require("@/assets/map/26091/420000.json"),
      //   }),
      //   style: new Style({
      //     renderer(coordinate, state) {
      //       // //////console.log("coordinate", coordinate);
      //       // //////console.log("state", state);
      //       coordinate.forEach((item) => {
      //         let arr = item[0];
      //         const ctx = state.context;
      //         gradient.forEach((color, index) => {
      //           that.addOutlineShadow(ctx, {
      //             coodArr: arr,
      //             fillStyle: color,
      //             y: -(index - 2),
      //           });
      //         });
      //       });
      //     },
      //   }),
      //   opacity: 1,
      //   className: "singlejson",
      //   zIndex: 2,
      //   visible: true,
      // });
      // return baseShadowVector;
      // 创建填充样式

      // const imageStyle = new Style({
      //   image: new StyleIcon({
      //     src: this.staticimage, // 替换为你的图片 URL
      //     anchor: [0.5, 0.5], // 锚点设置，根据图标调整
      //     opacity: 1,
      //     color: "rgba(0, 0, 0, 1)",
      //     offset: [10, 20],
      //     rotateWithView: true,
      //     // scale: 1,
      //     // shadowColor: "rgba(0, 0, 0, 0.5)", // 阴影颜色，这里是半透明黑色
      //     // shadowBlur: 10, // 阴影模糊度
      //     // shadowOffsetY: 5, // 阴影在 Y 轴上的偏移量
      //   }),
      // });
      // //console.log("imageStyle", imageStyle);
      return new LayerImage({
        source: new SourceImagestatic({
          url: this.staticimage,
          projection: "EPSG:3857",
          // imageExtent: layerExtentIn4326,
          imageExtent: layerExtentIn3857
        }),
        // style: imageStyle,
        opacity: 1,
        className: "static",
        zIndex: 4
      });
    },
    getShadowImageLayer() {
      const layerExtentIn4326 = [108.37271539853077, 28.891919914702427, 116.1294366014692, 33.29015874545334];
      // 转换边界的对角点到3857坐标系
      const bottomLeftIn3857 = fromLonLat([layerExtentIn4326[0], layerExtentIn4326[1]]);
      const topRightIn3857 = fromLonLat([layerExtentIn4326[2], layerExtentIn4326[3]]);
      // 创建在3857坐标系下的边界（注意：extent 是 [minx, miny, maxx, maxy]）
      const layerExtentIn3857 = [bottomLeftIn3857[0], bottomLeftIn3857[1], topRightIn3857[0], topRightIn3857[1]];
      // const upextent = layerExtentIn3857.map((item, index) => {
      //   return index === 1 || index === 3 ? item + 20000 : item;
      // });
      const gradient1 = this.formUserId == 1516351940 ? this.lerpColor("#CD7843", "#F7B74B", 20) : this.lerpColor("#2B97C6", "#09B8CB", 20);
      const feature = new Feature({
        geometry: fillPolygon
      });
      const shadowSource = new VectorSource({
        features: [feature]
      });
      const HoverShadowLayer = new VectorLayer({
        source: new VectorSource(),
        opacity: 1,
        className: "hovershadow",
        zIndex: 5,
        visible: true
      });
      let that = this;
      HoverShadowLayer.setSource(shadowSource);
      HoverShadowLayer.setStyle(new Style({
        renderer(coordinate, state) {
          // //////console.log("coordinate", coordinate);
          // //////console.log("state", state);
          coordinate.forEach(item => {
            let arr = item[0];
            const ctx = state.context;
            gradient1.forEach((color, index) => {
              that.addOutlineShadow(ctx, {
                coodArr: arr,
                fillStyle: color,
                y: -(index - 2)
              });
            });
          });
        }
      }));
    },
    /**
     * 加载GeoJson
     */
    getjsonlayer() {
      if (this.adcode === "region") {
        // 自定义json数据
        this.jsonSource = new VectorSource({
          features: new GeoJSON().readFeatures(this.geojson)
        });
      } else {
        // 乡镇街道json判断
        if (this.streetcode.length > 0) {
          this.jsonSource = new VectorSource({
            features: new GeoJSON().readFeatures(this.geojson, {
              dataProjection: "EPSG:4326",
              featureProjection: "EPSG:3857"
            })
          });
        } else {
          let apiurl = `${process.env.NODE_ENV === "development" ? "/fileapi" : location.origin}/frontendTest1/openlayers/data/`;
          if (this.adcode.includes(",")) {
            this.jsonSource = new VectorSource();
            let adcodes = _.cloneDeep(this.adcode).split(",");
            let adcodesArr = [];
            adcodes.forEach(elem => {
              adcodesArr.push(`${apiurl}${elem}${this.mapv2info.form.ishaschild === "是" ? "_full" : ""}.json`);
            });
            let that = this;
            adcodesArr.forEach(elem => {
              axios.get(elem).then(res => {
                let jsondata = new GeoJSON().readFeatures(res.data, {
                  dataProjection: "EPSG:4326",
                  featureProjection: "EPSG:3857"
                });
                that.mapv2info.form.ishaschild === "是" ? that.jsonSource.addFeatures(jsondata) : that.jsonSource.addFeature(jsondata[0]);
              });
            });
          } else {
            // 省市区县json
            this.jsonSource = new VectorSource({
              format: new GeoJSON(),
              url: `${apiurl}${this.adcode.includes("_full") ? this.adcode.replace("_full", "") : this.adcode}${this.mapv2info.form.ishaschild === "是" ? "_full" : ""}.json`
            });
          }
        }
      }
      return new VectorLayer({
        source: this.jsonSource,
        opacity: 1,
        style: this.jsonstyleFunction(),
        className: "json",
        zIndex: 3
      });
    },
    jsonstyleFunction() {
      return [new Style({
        stroke: new StyleStroke({
          color: "rgba(5, 146, 232, 1)",
          width: 1
        }),
        fill: new StyleFill({
          color: "rgba(5, 146, 232, 0.2)"
        })
      })];
    },
    gethoverLayer() {
      return new LayerImage({
        source: new SourceImagestatic({
          url: this.hoverImg,
          projection: "EPSG:3857",
          imageExtent: []
        }),
        opacity: 1,
        className: "hoverimg",
        zIndex: 6
      });
    },
    /**
     * 绘制图层
     */
    getDrawLayer(drawjson) {
      this.drawSource = new VectorSource();
      // 非遗地图移动端不显示绘制图层
      if (Object.keys(this.drawelement).length > 0 && this.drawelement.drawJson) {
        if (drawjson) {
          this.drawelement.drawJson = JSON.stringify(drawjson);
        }
        let data = this.drawelement;
        //////////////////////console.log('getDrawLayer')
        //////////////////////console.log(data)
        //////////////////////console.log(drawjson)
        const featureJson = new GeoJSON().readFeatures(data.drawJson);
        featureJson.forEach((feature, index) => {
          if (feature.get("name")) {
            let textstyle = feature.get("style");
            let name = feature.get("name");
            if (textstyle.align === 0) {
              name = name.replace(/\uff08/g, "\ufe35");
              name = name.replace(/\uff09/g, "\ufe36");
              name = name.split("").join("\n");
            } else {
              name = name.replace(/\ufe35/g, "\uff08");
              name = name.replace(/\ufe36/g, "\uff09");
            }
            feature.setStyle(new Style({
              text: new StyleText({
                text: name,
                font: `${textstyle.fontSize}px FZShengShiKaiShuS-DB-GB`,
                textBaseline: "top",
                textAlign: "left",
                fill: new StyleFill({
                  color: textstyle.color
                })
              })
            }));
          }
          if (feature.getGeometry() && feature.getGeometry().getType() === "LineString") {
            let linestyle = Object.keys(data.linestyle).length > 0 ? data.linestyle : this.drawstyle;
            feature.setStyle(new Style({
              stroke: new StyleStroke(linestyle)
            }));
          }
          if (feature.getGeometry() && feature.getGeometry().getType() === "GeometryCollection" && feature.get("type") === "circle") {
            let linestyle = Object.keys(data.linestyle).length > 0 ? data.linestyle : this.drawstyle;
            feature = new Feature({
              geometry: new Circle(feature.get("coordinate"), this.CircleRadius),
              type: "circle",
              coordinate: feature.get("coordinate")
            });
            feature.setStyle(new Style({
              fill: new StyleFill({
                color: linestyle.color
              }),
              stroke: new StyleStroke({
                color: linestyle.color,
                width: this.CircleRadius
              })
            }));
          }
          this.drawSource.addFeature(feature);
        });
        if (Object.keys(data.linestyle).length > 0) {
          this.drawstyle = data.linestyle;
        }

        //   this.drawSource.getFeatures().filter(e=>e&&e.getStyle()==null).forEach(e=>{
        //      e.setStyle(new Style({
        //   stroke: new StyleStroke({
        //     color: 'rgba(0, 56, 238, 0.35)',
        //     width: 4,
        //   })
        // }))
        // })
      }
      return new VectorLayer({
        source: this.drawSource,
        className: "draw",
        style: new Style({
          stroke: new StyleStroke(this.drawstyle)
        }),
        zIndex: 7
      });
    },
    drawSourceChange(evt) {
      //////////////////////////////////////////////console.log('evt',evt)
      let that = this;
      evt.target.getFeatures().forEach(feature => {
        if (feature.get("dindex") !== undefined) {
          let arrCoordinates = feature.getGeometry().getCoordinates();
          let defaultValue = [...arrCoordinates];
          let coordinates = [];
          // 两点 判断起始点 确定方向 绘制直角直线
          if (arrCoordinates.length === 2) {
            coordinates.push(defaultValue[0]);
            coordinates.push(that.getcurrentCoordinates(defaultValue[0], defaultValue[1]));
          }
          if (arrCoordinates.length > 2) {
            function setCoordinatesArr(i) {
              if (i === 0) {
                coordinates.push(defaultValue[i]);
                setCoordinatesArr(i + 1);
              } else if (i > defaultValue.length - 1) {
                return;
              } else {
                let nextC = that.getcurrentCoordinates(coordinates[i - 1], defaultValue[i]);
                coordinates.push(nextC);
                setCoordinatesArr(i + 1);
              }
            }
            setCoordinatesArr(0);
          }
          let features = [];
          // 创建直角线段的几何对象
          const geometry = new LineString(coordinates);

          // 创建具有直角线段几何对象的特性
          const linefeature = new Feature({
            geometry: geometry,
            findex: feature.get("dindex")
          });

          // 设置线的样式
          linefeature.setStyle(new Style({
            stroke: new StyleStroke(this.drawstyle)
          }));
          let lineStart = coordinates[0];
          let lineEnd = coordinates[coordinates.length - 1];
          let startCircleGeom = new Circle(lineStart, this.CircleRadius);
          let endCircleGeom = new Circle(lineEnd, this.CircleRadius);
          const circleitemStyle = new Style({
            fill: new StyleFill({
              color: this.drawstyle.color
            }),
            stroke: new StyleStroke({
              color: this.drawstyle.color,
              width: this.CircleRadius
            })
          });
          let startfeature = new Feature({
            geometry: startCircleGeom,
            type: "circle",
            coordinate: lineStart
          });
          startfeature.setStyle(circleitemStyle);
          let endfeature = new Feature({
            geometry: endCircleGeom,
            type: "circle",
            coordinate: lineEnd
          });
          endfeature.setStyle(circleitemStyle);
          features = [linefeature, startfeature, endfeature];
          this.drawSource.removeFeature(feature);
          this.drawSource.addFeatures(features);
        }
      });
    },
    /**
     * 更新地图
     */
    updateMap() {
      this.$nextTick(() => {
        //////////////////////////////////////////////console.log('更新地图');
        this.map.getView().setCenter(transform(this.center, "EPSG:4326", "EPSG:3857"));
        this.map.getView().setMinZoom(this.minZoom);
        this.map.getView().setMaxZoom(this.maxZoom);
        if (window.innerWidth <= 1500) {
          this.map.getView().setZoom(7.15);
          this.ih = 19;
        } else {
          this.map.getView().setZoom(this.zoom);
          this.ih = 26;
        }
        //////////////console.log("this.zoom", this.zoom);
        // 东胜地图添加旋转
        if (this.$route.query.fid === "166970") {
          // this.map.render()
          this.map.getView().on("change:rotation", evt => {
            //////////////////////////////////////////////console.log(evt);
            this.map.updateSize();
          });
          this.map.getView().setRotation(this.rotation);
        }
      });
    },
    /**
     * 单击地图操作
     */
    singleclick(val) {
      // 高德坐标
      let coordinateArr = transform(val.coordinate, "EPSG:3857", "EPSG:4326");
      // 绘制线段 禁止单击
      if (this.drawflag) return;
      // 绘制文字操作
      if (this.drawtextflag) {
        this.drawtextsingleflag = true;
        this.helpTooltipElement.innerHTML === "";
        this.helpTooltipElement.classList.add("hidden");
        if (this.drawtextsingleflag) {
          this.SET_MAPDRAWLAYERITEM({
            showtranfer: true
          });
          this.SET_MAPDRAWLAYERITEM({
            currentCoordinate: coordinateArr
          });
          return;
        }
      }
      let bdpoint = gaoDeToBaidu(coordinateArr[0].toFixed(6), coordinateArr[1].toFixed(6));
      this.$emit("singleclick", `${bdpoint.lng.toFixed(6)}, ${bdpoint.lat.toFixed(6)}`);
      // this.confirmPointHandle()
    },
    /**
     * 创建地图点位
     * @param {Array} val 点位数据
     */
    createPoint(val, city, citygroup, dxqinfo) {
      ////////////////////////////////console.log('createPoint',val)
      // if(city||citygroup){
      //   this.iconSource.clear()
      // }

      // ////////////////////////////////console.log('this.selectedFeatures',this.selectedFeatures)
      ////////////////////////////////console.log('val',val)
      this.iconSource.clear();
      if (val.length === 0) return;
      let that = this;
      val.forEach(elem => {
        let item = elem.itemformdata;
        let c = item.map_coordinates.split(",");
        let gd = bd_decrypt(Number(c[0]), Number(c[1]));
        let x = Number(gd.lng);
        let y = Number(gd.lat);
        ////////////////////////////console.log('item',item)
        // if(item.place_name=='荆楚理工学院'){
        //   //////////////////////////////////////////////console.log('item',item)
        //   //////////////////////////////////////////////console.log('elem',elem)
        // }
        // this.iconSource.getFeatures().forEach(e=>{
        //   //////////////////////////////////console.log('item.place_name')
        //   //////////////////////////////////console.log(item.place_name)

        //   // if(e.getStyle()[1].text_.text_==item.place_name){
        //   //   //////////////////////////////////console.log(e.getStyle()[1].text_.text_==item.place_name)
        //   //   e.getStyle()[1].text_.city=item['70']?item['70']:''
        //   //   e.getStyle()[1].text_.dxq=item['69']?item['69']:''
        //   //   alert(123)
        //   // }
        // })
        let obj = {
          name: item.place_name,
          image: item[4].length > 0 ? getImg(item[4][0]) : this.defaulticon,
          icon: item[75] != "" ? item[75][0].fileUrl : "",
          showPlaceName: item.showplace_name,
          showPlaceIcon: item.show4,
          showZhxyjsx: item["71"] ? item["71"] : "",
          showXxhx: item["72"] ? item["72"] : "",
          showSfxk: item["73"] ? item["73"] : "",
          city: item["70"] ? item["70"] : "",
          dxq: item["69"] ? item["69"] : "",
          mapCoordinates: item["map_coordinates"] ? item["map_coordinates"] : "",
          showHighlight: city ? item["70"] == city.values_.name ? true : false : dxqinfo ? dxqinfo == item["69"] ? true : false : false
        };
        let pointfeature = new Feature({
          geometry: new Point(fromLonLat([x, y])),
          id: elem.id,
          name: obj.name,
          image: obj.image,
          icon: "",
          xy: [x, y],
          score: 0
        });
        if (item[4].length > 0 && item[4][0].suffix === "gif") {
          obj.gif = getImg(item[4][0]);
          this.timer = setInterval(() => {
            if (gifler && that.style.pointStyleIndex) {
              const gifUrl = getImg(item[4][0]);
              const gif = gifler(gifUrl);
              gif.frames(document.createElement("canvas"), function (ctx, frame) {
                if (!pointfeature.getStyle()) {
                  pointfeature.setStyle(that.getStyle(obj, that.style.pointStyleIndex, ctx, frame));
                }
                ctx.clearRect(0, 0, frame.width, frame.height);
                ctx.drawImage(frame.buffer, frame.x, frame.y);
                that.map.render();
              }, true);
              clearInterval(that.timer);
              that.timer = null;
            }
          }, 100);
        } else {
          //////////////////////////////////console.log(`obj`, obj);
          //////////////////////////////////console.log(`this.getStyle(obj, 9)`,this.getStyle(obj, 9));
          pointfeature.setStyle(this.getStyle(obj, 9));
          // pointfeature.setStyle([this.getStyle(obj, this.style.pointStyleIndex),this.getStyle(obj, this.style.pointStyleIndex)])
        }
        this.iconSource.addFeature(pointfeature);
      });
      this.needAllFeture = this.iconSource.getFeatures();
      val.forEach(elem => {
        let item = elem.itemformdata;
        this.needAllFeture.forEach(e => {
          if (e.getStyle()[1].text_.text_ == item.place_name) {
            // //////////////////////////////////console.log(e.getStyle()[1].text_.text_==item.place_name)
            e.getStyle()[1].text_.city = item["70"] ? item["70"] : "";
            e.getStyle()[1].text_.dxq = item["69"] ? item["69"] : "";
          }
        });
      });

      // //////////////////////////////////console.log('this.needAllFeture',this.needAllFeture)
    },
    /**
     * 设置相应样式
     */
    getStyle(item, sIndex, ctx, frame) {
      let Styles = [];
      let stext = this.style.pointtext;
      let spic = this.style.pointpic;
      let sicon = this.style.pointicon;

      // 绘制圆角矩形
      let textsize = parseInt(stext.fontSize);
      let canvas = document.createElement("canvas");
      let canvas1 = document.createElement("canvas");
      let canvas2 = document.createElement("canvas");
      let context = canvas.getContext("2d");
      let namelen = item.name.length + 1;
      canvas.width = namelen * textsize;
      canvas.height = textsize + 6;
      canvas1.width = namelen * textsize;
      canvas1.height = textsize + 6;
      canvas2.width = namelen * textsize;
      canvas2.height = textsize + 6;
      let x = 0;
      let y = 0;
      let w = canvas.width;
      let h = canvas.height;
      let w1 = canvas1.width;
      let h1 = canvas1.height;
      let w2 = canvas2.width;
      let h2 = canvas2.height;
      let r = Math.ceil((textsize + 6) / 2);
      // 缩放
      context.scale(1, 1);
      context.fillStyle = stext.fill;
      //////////////////////////////////////////////console.log('stext.fill',stext.fill)
      //////////////////////////////////////////////console.log(context)
      // 绘制圆角矩形
      context.beginPath();
      context.moveTo(x + r, y);
      context.arcTo(x + w, y, x + w, y + h, r);
      context.arcTo(x + w, y + h, x, y + h, r);
      context.arcTo(x, y + h, x, y, r);
      context.arcTo(x, y, x + w, y, r);
      // 设置阴影
      // context.shadowColor = "rgba(0, 0, 0, 0.2)"; // 颜色
      // context.shadowBlur = 5 // 模糊尺寸
      // context.shadowOffsetX = 2 // 阴影Y轴偏移
      // context.shadowOffsetY = 2 // 阴影X轴偏移
      // ----
      context.closePath();
      // 填充
      context.fill();

      // //////////////console.log(spic.scale)
      //////////////console.log(spic.anchor);
      //////////////console.log(778899);

      let image = "";
      if (ctx) {
        image = new Style({
          image: new StyleIcon({
            img: ctx.canvas,
            opacity: 1,
            imgSize: [frame.width, frame.height],
            anchor: window.innerWidth <= 1500 ? [4, 0.5] : spic.anchor,
            scale: window.innerWidth <= 1500 ? 0.03 : spic.scale,
            rotateWithView: true
          })
        });
      } else {
        image = new Style({
          image: new StyleIcon({
            src: item.image,
            anchor: window.innerWidth <= 1500 ? [4, 0.5] : spic.anchor,
            scale: window.innerWidth <= 1500 ? 0.03 : spic.scale,
            rotateWithView: true
          })
        });
      }
      // 增加星星

      let icon = item.icon !== "" ? new Style({
        image: new StyleIcon({
          src: item.icon,
          // anchor: [-2.5,0.5],
          anchor: window.innerWidth <= 1500 ? [-(1 + item.name.length - 3.5), 0.5] : [-(1 + item.name.length - 3), 0.5],
          // scale:0.5,
          scale: window.innerWidth <= 1500 ? 0.3 : 0.5,
          rotateWithView: true
        })
      }) : "";
      // //////////////////////////////////console.log('12345')
      // //////////////////////////////////console.log((item.name.length-6)*((50/6)))
      // //////////////////////////////////console.log( Math.floor(-50-((50/6)*(item.name.length-6))) )
      //////////////console.log(910);
      //////////////console.log([w, h]);
      let text = new Style({
        image: new StyleIcon({
          img: canvas,
          imgSize: [w, h],
          rotateWithView: true
        }),
        text: new StyleText({
          text: item.name,
          // font: `${stext.fontSize} sans-serif`,
          font: window.innerWidth <= 1500 ? `10px sans-serif` : `${stext.fontSize} sans-serif`,
          // offsetY: 1,
          offsetY: 1,
          // offsetX: Math.floor(-60-((50/6)*(item.name.length-6))),
          offsetX: -35,
          textAlign: item.name.length > 6 ? "left" : "left",
          fill: item.showHighlight ? new StyleFill({
            color: "#ffffff"
          }) : new StyleFill({
            color: stext.color
          }),
          stroke: item.showHighlight ? new StyleStroke({
            color: "#045578",
            width: 2
          }) : stext.stroke !== "" ? new StyleStroke({
            color: stext.stroke,
            width: 3
          }) : "",
          // 这是高亮效果
          // fill: new StyleFill({ color: '#ffffff' }),
          // stroke: new StyleStroke({ color: '#045578', width: 2 }),
          rotateWithView: true
        })
      });
      //////////////////////////////////////////////console.log('canvas1',canvas1)
      //////////////////////////////////////////////console.log('w1',w1)
      //////////////////////////////////////////////console.log('h1',h1)
      let text1 = new Style({
        image: new StyleIcon({
          img: canvas1,
          imgSize: [w1, h1],
          rotateWithView: true
        }),
        text: new StyleText({
          textAlign: "center",
          text: "学校画像",
          font: `${stext.fontSize} sans-serif`,
          offsetY: 0.5,
          offsetX: 80,
          fill: new StyleFill({
            color: "#56BBFB"
          }),
          stroke: stext.stroke !== "" ? new StyleStroke({
            color: "#56BBFB",
            width: 4
          }) : "",
          rotateWithView: true
        })
      });
      let text2 = new Style({
        image: new StyleIcon({
          img: canvas2,
          imgSize: [w2, h2],
          rotateWithView: true
        }),
        text: new StyleText({
          textAlign: "center",
          text: "巡课",
          font: `${stext.fontSize} sans-serif`,
          offsetY: 0.5,
          offsetX: 120,
          fill: new StyleFill({
            color: stext.color
          }),
          stroke: stext.stroke !== "" ? new StyleStroke({
            color: stext.stroke,
            width: 1
          }) : "",
          rotateWithView: true
        })
      });
      // -3.1
      let addValue1 = -2.1;
      let addValue2 = -2.4;
      if (item["showZhxyjsx"] == "是") {
        addValue1 = -3.1;
      }
      if (item["showZhxyjsx"] == "否") {
        addValue1 = -2.1;
      }
      if (item["showZhxyjsx"] == "是" && item["showSfxk"] == "是") {
        addValue2 = -2.4;
      }
      if (item["showZhxyjsx"] == "是" && item["showSfxk"] == "否") {
        addValue2 = -1.7;
      }
      if (item["showZhxyjsx"] == "否" && item["showSfxk"] == "否") {
        addValue2 = -1.1;
      }
      if (item["showZhxyjsx"] == "否" && item["showSfxk"] == "是") {
        addValue2 = -1.7;
      }
      let icon1 = item.icon !== "" ? new Style({
        image: new StyleIcon({
          src: this.lightIcon[3],
          anchor: window.innerWidth <= 1500 ? [addValue1 + 1, 0.5] : [addValue1, 0.5],
          scale: window.innerWidth <= 1500 ? 0.8 : 1,
          rotateWithView: true
        })
      }) : "";
      let icon2 = item.icon !== "" ? new Style({
        image: new StyleIcon({
          src: this.lightIcon[4],
          anchor: window.innerWidth <= 1500 ? [addValue2 + 0.5, 0.5] : [addValue2, 0.5],
          scale: window.innerWidth <= 1500 ? 0.8 : 1,
          rotateWithView: true
        })
      }) : "";
      if (sIndex === 0) {
        Styles.push(image);
        Styles.push(text);
      }
      if (sIndex === 1 || sIndex === 5) Styles.push(image);
      if (sIndex === 2 || sIndex === 7) Styles.push(icon);
      if (sIndex === 3) Styles.push(text);
      if (sIndex === 4 || sIndex === 6) {
        Styles.push(icon);
        Styles.push(text);
      }
      if (sIndex === 8) {
        Styles.push(image);
        Styles.push(icon);
        Styles.push(text);
      }
      if (sIndex === 9) {
        //////////////////////////////////////////console.log('item',item)
        // //////////////////////////////////////////////console.log('show4',item['show4'])
        if (item["showPlaceIcon"] == "是") {
          Styles.push(image);
        }
        if (item["showPlaceName"] == "是") {
          Styles.push(text);
        }
        if (item["showZhxyjsx"] == "是") {
          Styles.push(icon);
        }
        if (item["showXxhx"] == "是") {
          Styles.push(icon1);
        }
        if (item["showSfxk"] == "是") {
          Styles.push(icon2);
        }
      }
      return Styles;
    },
    /**
     * 单击点位操作
     */
    markerclick(evt) {
      console.log("click", evt);
      // this.map.removeInteraction(this.selectinter)
      // this.map.addInteraction(this.selectinter)
      // if (this.isnotclick || !this.iseditpoint) return;
      if (!this.iseditpoint && this.formUserId != 1514653091) {
        // 判断feature类型
        let feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
          return feature;
        });
        let gtype = feature.getGeometry().getType();
        // point显示弹窗详情
        if (gtype === "Point") {
          let id = feature.get("id");
          let score = feature.get("score");
          ////////////console.log("score", score);
          let currentInfo = "";
          if (this.pointlist.length > 0) currentInfo = this.pointlist.find(item => {
            return item.id === id;
          });
          if (currentInfo === undefined) return;
          // 标准模版获取弹窗
          if (score === 0) this.standardDetail(currentInfo);
          // 非遗模版获取弹窗
          // if (score === 1) this.culturalDetail(currentInfo, feature);
        }
      }
      if (this.isnotclick || !this.iseditpoint) return;
      let feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        return feature;
      });
      this.map.removeInteraction(this.selectinter);
      ////////////////////console.log('feature')
      ////////////////////console.log(feature)
      // ////////////////////console.log(feature.get('xy'))
      // ////////////////////console.log(feature.values_.type)
      // ////////////////////console.log(feature.values_.level)
      // ////////////////////console.log(feature.values_.type)
      if (feature && feature.values_.level == undefined) {
        if (feature.get("xy") == undefined && feature.values_.level == undefined && feature.values_.level == "areaicon") {
          // ////////////////////console.log(feature)
          if (feature.values_.level == "city") this.map.removeInteraction(this.selectinter);
          if (feature.values_.level == undefined) this.map.addInteraction(this.selectinter);
          // if(feature.values_.level=='city'){
          //   this.map.removeInteraction(this.selectinter)
          // }
        } else {
          this.map.addInteraction(this.selectinter);
        }
      }
      if (feature && feature.getStyle() != null && feature.getStyle().length == undefined) {
        ////////////////////console.log('我是按钮')
        this.map.removeInteraction(this.selectinter);
        if (feature.values_.type == "areaicon") {
          this.map.addInteraction(this.selectinter);
        }
        if (feature.values_.type == "areapolygon") {
          this.map.addInteraction(this.selectinter);
        }
        if (feature.values_.type == "arealine") {
          this.map.addInteraction(this.selectinter);
        }
        ////////////////////console.log(feature)
        let oid;
        let left;
        let mid;
        let right;
        oid = feature.ol_uid;
        let point = buttonForArea.find(o => oid * 1 == o.bid);
        ////////////////////console.log('oid',oid)
        ////////////////////console.log('point',point)
        // if(point){
        //   let areaIndex=point.areaid
        //   ////////////////////console.log('areaIndex',areaIndex)
        //   this.onClickClearAll(areaIndex)
        // }
        this.allLineInfo.forEach(e => {
          if (e.lid == feature.ol_uid) {
            left = feature;
            mid = this.drawSource.getFeatures().find(o => o.ol_uid == e.id);
            right = this.drawSource.getFeatures().find(o => o.ol_uid == e.rid);
          }
          if (e.rid == feature.ol_uid) {
            right = feature;
            mid = this.drawSource.getFeatures().find(o => o.ol_uid == e.id);
            left = this.drawSource.getFeatures().find(o => o.ol_uid == e.lid);
          }
        });
        if (left && mid && right) {
          ElMessageBox.confirm("确定要重置学校点位吗？", "温馨提示", {
            distinguishCancelAndClose: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消"
          }).then(res => {
            if (res == "confirm") {
              if (point) {
                let areaIndex = point.areaid;
                ////////////////////console.log('areaIndex',areaIndex)
                this.onClickClearAll(areaIndex);
              }
              this.drawSource.removeFeature(left);
              this.drawSource.removeFeature(mid);
              this.drawSource.removeFeature(right);
              this.map.addInteraction(this.selectinter);
            }
          }).catch(() => {
            this.map.addInteraction(this.selectinter);
          });
        }
        // this.drawSource.removeFeature(left);
        // this.drawSource.removeFeature(mid);
        //  this.drawSource.removeFeature(right);
      }
      if (feature && feature.geometry && feature.geometry.type === "LineString") {
        //////////////////////console.log('line')
        //////////////////////console.log('feature')
      }
      // //////////////////////console.log('len',this.drawSource.getFeatures().filter(e=>e&&e.getStyle()==null))
      if (feature && feature.getStyle() == null) {
        //////////////////////console.log('我是折线')
        //////////////////////console.log(feature)
        //////////////////////console.log(feature.getStyle())
        // this.drawSource.removeFeature(feature);
        // this.initMap()
        // feature.setStyle(new Style({
        //     fill: new StyleFill({ color: 'rgba(0, 0, 0, 0)' }),
        // stroke: new StyleStroke({
        //   color: 'rgba(0, 0, 0, 0)',
        //   width: 1,
        // })
        //   }))
        // this.allGeometry.push(feature)
        // localStorage.setItem('feature', JSON.stringify(this.allGeometry) )
      }

      //////////////////////console.log('this.geoJsonData.features')
      //////////////////////console.log( this.drawSource.getFeatures())

      this.$emit("markerclick", feature);
    },
    /**
     * 鼠标移入点位操作 动效
     */
    /**
     * 标准模版获取点位详情
     * @param {Object} feature 选中数据
     */
    standardDetail(currentInfo) {
      let formatinfo = {};
      Object.keys(currentInfo.itemformdata).forEach(key => {
        formatinfo[key] = currentInfo.itemformdata[key];
      });
      formatinfo.audio = formatinfo.audio.length > 0 ? formatinfo.audio.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, "");
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : "";
      formatinfo.video = formatinfo.video.length > 0 ? formatinfo.video.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, "");
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : "";
      formatinfo.audiodesc = formatinfo.audiodesc && formatinfo.audiodesc.length > 0 ? formatinfo.audiodesc.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, "");
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : "";
      //////////////////console.log(`formatinfo.video`, formatinfo.video);

      if (formatinfo["42"] === "弹窗") {
        this.pointdetail = formatinfo;
        this.popshowflag = true;
      }
      // if (formatinfo["42"] === "链接" && formatinfo["44"] !== "") {
      //   let url = formatinfo["44"];
      //   if (formatinfo["44"].includes("superMapv2")) {
      //     let cparams = formatinfo["44"].split("?")[1];
      //     url =
      //       location.protocol +
      //       "//" +
      //       location.host +
      //       location.pathname +
      //       "?page=superMapv2?" +
      //       cparams;
      //   }
      //   window.open(this.ensureHttpsPrefix(url));
      // }
      if (formatinfo["77"] !== "" && this.formUserId == 1516351940) {
        let url = formatinfo["77"];
        if (formatinfo["77"].includes("superMapv2")) {
          let cparams = formatinfo["77"].split("?")[1];
          url = location.protocol + "//" + location.host + location.pathname + "?page=superMapv2?" + cparams;
        }
        window.open(this.ensureHttpsPrefix(url));
      }
      if (formatinfo["76"] !== "" && this.formUserId == 1516336824) {
        let url = formatinfo["76"];
        if (formatinfo["76"].includes("superMapv2")) {
          let cparams = formatinfo["76"].split("?")[1];
          url = location.protocol + "//" + location.host + location.pathname + "?page=superMapv2?" + cparams;
        }
        window.open(this.ensureHttpsPrefix(url));
      }
    },
    ensureHttpsPrefix(url) {
      // 使用正则表达式检查是否以 http:// 或 https:// 开头
      const regex = /^(https?:\/\/)/;

      // 如果不匹配，则拼接 https://
      if (!regex.test(url)) {
        return "https://" + url;
      }

      // 如果已经包含 http:// 或 https://，则直接返回原字符串
      return url;
    },
    markermove(evt) {
      // //console.log(evt);
      let feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        return feature;
      });
      // console.log("feature", feature);
      // if (feature && feature.ol_uid) //console.log("feature.ol_uid", feature.ol_uid);

      // while (this.boxLayers.length > 0) {
      //   const layer = this.boxLayers.pop(); // 移除最后一个图层的引用
      //   this.map.removeLayer(layer); // 从地图上移除图层
      // }
      // while (this.shadowLayers.length > 0) {
      //   const layer = this.shadowLayers.pop(); // 移除最后一个图层的引用
      //   this.map.removeLayer(layer); // 从地图上移除图层
      // }
      // while (this.hoverLayers.length > 0) {
      //   const layer = this.hoverLayers.pop(); // 移除最后一个图层的引用
      //   this.map.removeLayer(layer); // 从地图上移除图层
      // }
      // this.map
      //   .getLayers()
      //   .getArray()
      //   .forEach((item) => {
      //     if (item.className_ === "hoverimg") {
      //       item.setVisible(false);
      //     }
      //   });
      if (feature && feature.ol_uid) {
        if (feature.ol_uid != this.currentFeatureId) {
          this.currentFeatureId = feature.ol_uid;
          // //console.log("不同");
          {
            let currentPoint = "";
            let currentArea = "";
            let allfeatures = this.needAllFeture;
            allfeatures.forEach(e => {
              let obj = e.getStyle();
              if (obj[1]) {
                obj[1].text_.fill_ = new StyleFill({
                  color: "#333333"
                });
                obj[1].text_.stroke_ = null;
                e.setStyle(obj);
              }
            });
            while (this.boxLayers.length > 0) {
              const layer = this.boxLayers.pop(); // 移除最后一个图层的引用
              this.map.removeLayer(layer); // 从地图上移除图层
            }
            while (this.shadowLayers.length > 0) {
              const layer = this.shadowLayers.pop(); // 移除最后一个图层的引用
              this.map.removeLayer(layer); // 从地图上移除图层
            }
            while (this.hoverLayers.length > 0) {
              const layer = this.hoverLayers.pop(); // 移除最后一个图层的引用
              this.map.removeLayer(layer); // 从地图上移除图层
            }
            this.map.getLayers().getArray().forEach(item => {
              if (item.className_ === "hoverimg") {
                item.setVisible(false);
              }
            });
            if (this.drawflag || this.drawtextflag) {
              if (this.deleteflag) return;
              if (this.drawtextsingleflag) return;
              if (this.drawflag) this.helpTooltipElement.innerHTML = this.drawsketch ? "点击继续绘制线，双击结束绘制" : this.drawsketch ? "拖动修改" : "点击开始绘制";
              if (this.drawtextflag) this.helpTooltipElement.innerHTML = "点击选择位置后 添加点位名称";
              this.helpTooltip.setPosition(evt.coordinate);
              this.helpTooltipElement.classList.remove("hidden");
              return;
            }
            let sIndex = this.style.pointStyleIndex;
            if (this.cfeature !== null) {
              let obj = {
                name: this.cfeature.get("name"),
                image: this.cfeature.get("image"),
                icon: this.cfeature.get("icon")
              };
              if (sIndex === 5) this.cfeature.setStyle(this.getStyle(obj, 1));
              if (sIndex === 6) this.cfeature.setStyle(this.getStyle(obj, 6));
              if (sIndex === 7) this.cfeature.setStyle(this.getStyle(obj, 7));
              // if (sIndex === 0) feature.setStyle(this.getStyle(obj, 9))
              this.cfeature = null;
            }
            this.map.getTarget().style.cursor = "";
            // 判断鼠标划过点位

            if (feature && feature.get("xy")) {
              this.map.getTarget().style.cursor = "pointer";
              let obj = feature.getStyle();
              if (obj.length >= 2) {
                // obj[1].text_.fill_ = new StyleFill({ color: "#ffffff" });
                obj[1].text_.fill_ = new StyleFill({
                  color: "rgba(54, 68, 217, 1)"
                });
                feature.setStyle(obj);
              }
              let cid = feature.get("id");
              let allfeatures = this.iconSource.getFeatures();
              allfeatures.forEach(item => {
                let id = item.get("id");
                let obj = {
                  name: item.get("name"),
                  image: item.get("image"),
                  icon: item.get("icon")
                };
                if (cid === id) {
                  currentPoint = item;
                  this.cfeature = feature;
                  if (currentPoint.getStyle().length >= 2) {
                    let cur = this.formUserId == 1516351940 ? this.hightlightCityXunke.find(e => e.city == currentPoint.getStyle()[1].text_.city) : this.hightlightCity.find(e => e.city == currentPoint.getStyle()[1].text_.city);
                    let allFeatures = [];
                    const layers = this.map.getLayers().getArray();
                    layers.forEach(layer => {
                      if (layer instanceof VectorLayer) {
                        const source = layer.getSource();
                        if (source) {
                          const features = source.getFeatures();
                          allFeatures = allFeatures.concat(features);
                        }
                      }
                    });
                    // ////console.log("cur", cur);
                    // ////console.log("allFeatures", allFeatures);
                    let features = allFeatures.filter(e => e.values_.level == "city" && e.values_.name == cur.city);
                    // this.changeShadow2(item, cur.imageExtent, cur);
                    if (this.formUserId == 1516351940) {
                      this.changeShadow1(features, cur.imageExtent, cur, "wh");
                    } else {
                      this.changeShadow1(features, cur.imageExtent, cur, "wh");
                    }

                    // 12656683.473857919
                    this.map.getLayers().getArray().forEach(item => {
                      if (item.className_ === "hoverimg") {
                        // const upextent = cur.imageExtent.map((item, index) => {
                        //   return index === 1 || index === 3 ? item + 20000 : item;
                        // });
                        let curExent = [...cur.imageExtent];
                        // cur.imageExtent[1] = cur.imageExtent[1] + 20000;
                        // cur.imageExtent[3] = cur.imageExtent[3] + 20000;
                        ////console.log("cur.imageExtent", cur.imageExtent);
                        ////console.log("curExent", curExent);
                        curExent[1] = curExent[1] + 20000;
                        curExent[3] = curExent[3] + 20000;
                        // ////console.log("upextent", upextent);
                        if (cur) {
                          if (cur.city == "武汉市" && this.firstMove) {
                            this.firstMove = false;
                          }
                          item.setVisible(true);
                          // 假设 item 有一个包含矢量元素的属性，比如 features 或 layers
                          item.setSource(new SourceImagestatic({
                            url: cur.url,
                            projection: "EPSG:3857",
                            imageExtent: curExent
                            // imageExtent: this.hoverLayers.length
                            //   ? upextent
                            //   : cur.imageExtent,
                          }));
                        }
                      }
                    });
                  }
                }
              });
            }
            // 判断鼠标划过市区域
            if (feature && !feature.get("xy")) {
              ////console.log("feature", feature);
              let allfeatures = this.iconSource.getFeatures();
              // this.currentArea={}
              let code = Number(feature.get("adcode"));
              let geometry = feature.get("geometry");
              let current = this.hoverImgList.find(elem => {
                return elem.code === code;
              });
              // //////console.log("current", current);
              //////console.log("feature", feature);

              //////////////console.log("geometry.extent_", geometry.extent_);
              let extent = geometry.extent_.map((item, index) => {
                // if (index === 0 || index === 1) item = item - 600
                // if (index === 2 || index === 3) item = item + 600
                //  if (index === 0 || index === 1) item = item -8000
                // if (index === 2 || index === 3) item = item + 11000;
                return item;
              });
              if (current && extent) {
                this.changeShadow(feature, extent, current);
                // const gradient1 = this.lerpColor("#A2393B", "#F7B74B", 20);
                // const shadowSource = new VectorSource({ features: [feature] });
                // //////console.log("gradient1", gradient1);
                // const HoverShadowLayer = new VectorLayer({
                //   source: new VectorSource(),
                //   opacity: 1,
                //   className: "hovershadow",
                //   zIndex: 5,
                // });
                // this.map.addLayer(HoverShadowLayer);
                // let that = this;
                // HoverShadowLayer.setSource(shadowSource);
                // HoverShadowLayer.setStyle(
                //   new Style({
                //     renderer(coordinate, state) {
                //       // //////console.log("coordinate", coordinate);
                //       // //////console.log("state", state);
                //       coordinate.forEach((item) => {
                //         let arr = item[0];
                //         const ctx = state.context;
                //         gradient1.forEach((color, index) => {
                //           that.addOutlineShadow(ctx, {
                //             coodArr: arr,
                //             fillStyle: color,
                //             y: -(index - 2),
                //           });
                //         });
                //       });
                //     },
                //   })
                // );
                // const HoverImageLayer = new LayerImage({
                //   source: new SourceImagestatic({
                //     url: current.image,
                //     projection: "EPSG:3857",
                //     imageExtent: upextent,
                //   }),
                //   opacity: 1,
                //   className: "hover",
                //   zIndex: 7,
                // });
                // this.map.addLayer(HoverImageLayer);
                // this.shadowLayers.push(HoverShadowLayer);
                // this.hoverLayers.push(HoverImageLayer);
              }
              // this.map
              //   .getLayers()
              //   .getArray()
              //   .forEach((item) => {
              //     if (item.className_ === "hoverimg") {
              //       if (current) {
              //         if (current.code == 420100 && this.firstMove2) {
              //           this.firstMove2 = false;
              //         }
              //         //////console.log(item instanceof LayerImage);
              //         //////console.log("item", item);
              //         item.setVisible(true);
              //         item.setSource(
              //           new SourceImagestatic({
              //             url: current.image,
              //             projection: "EPSG:3857",
              //             imageExtent: extent,
              //           })
              //         );
              //         this.changeShadow(item, extent);
              //       }
              //     }
              //   });

              allfeatures.forEach(e => {
                let obj = e.getStyle();
                if (e.getStyle()[1] && e.getStyle()[1].text_.city == feature.values_.name) {
                  //////////////////////////////console.log('e')
                  //////////////////////////////console.log(e)
                  e.getStyle()[1].text_.preStyle = obj;
                  // obj[1].text_.fill_ = new StyleFill({ color: "#ffffff" });
                  // obj[1].text_.stroke_ = new StyleStroke({ color: "#045578", width: 2 });
                  obj[1].text_.fill_ = new StyleFill({
                    color: "rgba(54, 68, 217, 1)"
                  });
                  this.changeFontStyle2(e);
                  e.setStyle(obj);
                } else {}
              });
            }
            if (feature === undefined) {
              this.map.getLayers().getArray().forEach(item => {
                if (item.className_ === "hoverimg") item.setVisible(false);
              });
            }
            let dxq = "";
            // 襄阳都市圈
            const topLeftXy = [12330121.334888326, 3807405.389704013]; // 替换为实际坐标
            const bottomLeftXy = [12329040.347432509, 3782542.7032834725]; // 替换为实际坐标
            const topRightXy = [12485783.528526135, 3806324.4033379024]; // 替换为实际坐标
            const bottomRightXy = [12485783.528526135, 3784704.6760156937]; // 替换为实际坐标
            const mousePosition = this.map.getEventCoordinate(evt.originalEvent);
            const isInRectangleXy = mousePosition[0] >= bottomLeftXy[0] && mousePosition[0] <= topRightXy[0] && mousePosition[1] <= topLeftXy[1] && mousePosition[1] >= bottomRightXy[1];
            // 提取坐标值
            // const [x1, y1] = topLeftXy;
            // const [x2, y2] = bottomLeftXy;
            // const [x3, y3] = topRightXy;
            // const [x4, y4] = bottomRightXy;

            // // 计算最小和最大坐标值
            // const minX = Math.min(x1, x2, x3, x4);
            // const minY = Math.min(y1, y2, y3, y4);
            // const maxX = Math.max(x1, x2, x3, x4);
            // const maxY = Math.max(y1, y2, y3, y4);

            // // 创建 extent
            // const extent = [minX, minY, maxX, maxY];

            // ////////console.log("extent", extent);
            // 根据判断结果执行相应操作
            if (isInRectangleXy) {
              ////////////////////////////console.log('this.hoverImgList')
              ////////////////////////////console.log(this.hoverImgList)
              dxq = "襄阳都市圈";
              ////////////////////////////console.log('this.map.getLayers()',this.map.getLayers())
              let dxqImg = this.hoverImgList.filter(elem => {
                return elem.dxq === dxq;
              });
              //
              let ar = [];

              // 整个都市圈高亮
              let extent = [...this.arrXiangyang[1]];
              this.arrXiangyang.forEach((item, index) => {
                extent[0] = Math.min(extent[0], item[0]);
                extent[1] = Math.min(extent[1], item[1]) - 3000;
                extent[2] = Math.max(extent[2], item[2]);
                extent[3] = Math.max(extent[3], item[3]);
              });
              // ////console.log(feature);
              // ////console.log(extent);
              // ////console.log(cdata.mapHubeihoverImgDxqXunke[1]);
              // while (this.boxLayers.length > 0) {
              //   const layer = this.boxLayers.pop(); // 移除最后一个图层的引用
              //   this.map.removeLayer(layer); // 从地图上移除图层
              // }
              // while (this.shadowLayers.length > 0) {
              //   const layer = this.shadowLayers.pop(); // 移除最后一个图层的引用
              //   this.map.removeLayer(layer); // 从地图上移除图层
              // }
              // while (this.hoverLayers.length > 0) {
              //   const layer = this.hoverLayers.pop(); // 移除最后一个图层的引用
              //   this.map.removeLayer(layer); // 从地图上移除图层
              // }
              // ////console.log("this.drawSource.getFeatures()", this.drawSource.getFeatures());
              // ////console.log("this.drawSource.getFeatures()", this.map.getFeatures());
              // ////console.log(
              //   "this.drawSource.getFeatures123()",
              //   this.drawSource.getFeatures().filter((e) => e.ol_uid == "591")
              // );
              // ////console.log(
              //   "this.drawSource.getFeatures123()",
              //   this.drawSource
              //     .getFeatures()
              //     .filter((e) => e.values_.level && e.values_.level == "city")
              // );
              let allFeatures = [];
              const layers = this.map.getLayers().getArray();
              layers.forEach(layer => {
                if (layer instanceof VectorLayer) {
                  const source = layer.getSource();
                  if (source) {
                    const features = source.getFeatures();
                    allFeatures = allFeatures.concat(features);
                  }
                }
              });
              let features = allFeatures.filter(e => e.values_.level == "city" && (e.values_.name == "十堰市" || e.values_.name == "襄阳市" || e.values_.name == "随州市" || e.values_.name == "神农架林区"));
              // features.forEach((e) => {
              //   this.changeFontStyle2(e);
              // });
              if (this.formUserId == 1516351940) {
                this.changeShadow1(features, extent, cdata.mapHubeihoverImgDxqXunke[1], "xy");
              } else {
                this.changeShadow1(features, extent, cdata.mapHubeihoverImgDxqJiaohu[1], "xy");
              }
              this.map.getLayers().getArray().forEach(item => {
                if (item.className_ === "hoverimg") {
                  const upextent = extent.map((item, index) => {
                    return index === 1 || index === 3 ? item + 20000 : item;
                  });
                  item.setVisible(true);
                  if (this.formUserId == 1516351940) {
                    item.setSource(new SourceImagestatic({
                      url: cdata.mapHubeihoverImgDxqXunke[1].image,
                      projection: "EPSG:3857",
                      imageExtent: this.hoverLayers.length ? upextent : extent
                    }));
                  } else {
                    item.setSource(new SourceImagestatic({
                      url: cdata.mapHubeihoverImgDxqJiaohu[1].image,
                      projection: "EPSG:3857",
                      imageExtent: this.hoverLayers.length ? upextent : extent
                    }));
                  }
                }
              });

              // this.map
              //   .getLayers()
              //   .getArray()
              //   .forEach((item) => {
              //     if (item.className_ === "hoverimg") {
              //       item.setVisible(true);
              //       if (this.formUserId == 1516351940) {
              //         item.setSource(
              //           new SourceImagestatic({
              //             url: cdata.mapHubeihoverImgDxqXunke[1].image,
              //             projection: "EPSG:3857",
              //             imageExtent: extent,
              //           })
              //         );
              //       } else {
              //         item.setSource(
              //           new SourceImagestatic({
              //             url: cdata.mapHubeihoverImgDxqJiaohu[1].image,
              //             projection: "EPSG:3857",
              //             imageExtent: extent,
              //           })
              //         );
              //       }
              //     }
              //   });

              // 点位高亮
              allfeatures.forEach(e => {
                let obj = e.getStyle();
                if (e.getStyle()[1] && e.getStyle()[1].text_.dxq == dxq) {
                  e.getStyle()[1].text_.preStyle = obj;
                  // obj[1].text_.fill_ = new StyleFill({ color: "#ffffff" });
                  // obj[1].text_.stroke_ = new StyleStroke({ color: "#045578", width: 2 });
                  obj[1].text_.fill_ = new StyleFill({
                    color: "rgba(54, 68, 217, 1)"
                  });
                  this.changeFontStyle2(e);
                  e.setStyle(obj);
                } else {}
              });

              // this.createPoint (this.pointlist,null,allfeatures,dxq)
            } else {}
            // 武汉都市圈
            const topLeftWh = [12710408.398191964, 3571750.361891935]; // 替换为实际坐标
            const bottomLeftWh = [12709327.41537128, 3550130.6345697264]; // 替换为实际坐标
            const topRightWh = [12862826.975908397, 3572831.348258046]; // 替换为实际坐标
            const bottomRightWh = [12863907.95872908, 3547968.6618375056]; // 替换为实际坐标

            const mousePositionWh = this.map.getEventCoordinate(evt.originalEvent);
            //////////console.log("mousePositionWh", mousePositionWh);
            ////////////////////////////////////console.log(mousePositionWh)
            const isInRectangleWh = mousePositionWh[0] >= bottomLeftWh[0] && mousePositionWh[0] <= topRightWh[0] && mousePositionWh[1] <= topLeftWh[1] && mousePositionWh[1] >= bottomRightWh[1];
            // 根据判断结果执行相应操作
            if (isInRectangleWh) {
              dxq = "武汉都市圈";
              let extent = [...this.arrWuhan[1]];
              this.arrWuhan.forEach((item, index) => {
                extent[0] = Math.min(extent[0], item[0]) - 200;
                extent[1] = Math.min(extent[1], item[1]) + 2600;
                extent[2] = Math.max(extent[2], item[2]);
                extent[3] = Math.max(extent[3], item[3]);
              });
              let allFeatures = [];
              const layers = this.map.getLayers().getArray();
              layers.forEach(layer => {
                if (layer instanceof VectorLayer) {
                  const source = layer.getSource();
                  if (source) {
                    const features = source.getFeatures();
                    allFeatures = allFeatures.concat(features);
                  }
                }
              });
              let features = allFeatures.filter(e => e.values_.level == "city" && (e.values_.name == "潜江市" || e.values_.name == "天门市" || e.values_.name == "仙桃市" || e.values_.name == "孝感市" || e.values_.name == "武汉市" || e.values_.name == "鄂州市" || e.values_.name == "黄石市" || e.values_.name == "咸宁市" || e.values_.name == "黄冈市"));
              if (this.formUserId == 1516351940) {
                this.changeShadow1(features, extent, cdata.mapHubeihoverImgDxqXunke[0], "wh");
              } else {
                this.changeShadow1(features, extent, cdata.mapHubeihoverImgDxqJiaohu[0], "wh");
              }
              this.map.getLayers().getArray().forEach(item => {
                if (item.className_ === "hoverimg") {
                  const upextent = extent.map((item, index) => {
                    return index === 1 || index === 3 ? item + 20000 : item;
                  });
                  item.setVisible(true);
                  if (this.formUserId == 1516351940) {
                    item.setSource(new SourceImagestatic({
                      url: cdata.mapHubeihoverImgDxqXunke[0].image,
                      projection: "EPSG:3857",
                      imageExtent: this.hoverLayers.length ? upextent : extent

                      // imageExtent: extent,
                    }));
                  } else {
                    item.setSource(new SourceImagestatic({
                      url: cdata.mapHubeihoverImgDxqJiaohu[0].image,
                      projection: "EPSG:3857",
                      imageExtent: this.hoverLayers.length ? upextent : extent
                      // imageExtent: extent,
                    }));
                  }
                }
              });
              allfeatures.forEach(e => {
                if (e.getStyle()[1] && e.getStyle()[1].text_.dxq == dxq) {
                  let obj = e.getStyle();
                  // //////////////////////////////////console.log('e1234',obj)
                  e.getStyle()[1].text_.preStyle = obj;
                  // obj[1].text_.fill_ = new StyleFill({ color: "#ffffff" });
                  // obj[1].text_.stroke_ = new StyleStroke({ color: "#045578", width: 2 });
                  obj[1].text_.fill_ = new StyleFill({
                    color: "rgba(54, 68, 217, 1)"
                  });
                  this.changeFontStyle2(e);
                  e.setStyle(obj);
                } else {
                  // e.setStyle(e.getStyle()[1].text_.preStyle)
                }
              });
              // this.createPoint (this.pointlist,null,allfeatures,dxq)
            } else {}

            // 宜荆荆都市圈
            const topLeftYjj = [12249909.716580614, 3593370.0892141443]; // 替换为实际坐标
            const bottomLeftYjj = [12247747.750939246, 3567426.4164274936]; // 替换为实际坐标
            const topRightYjj = [12440162.693020985, 3592289.102848034]; // 替换为实际坐标
            const bottomRightYjj = [12438000.727379616, 3568507.402793604]; // 替换为实际坐标

            const mousePositionYjj = this.map.getEventCoordinate(evt.originalEvent);
            const isInRectangleYjj = mousePositionYjj[0] >= bottomLeftYjj[0] && mousePositionYjj[0] <= topRightYjj[0] && mousePositionYjj[1] <= topLeftYjj[1] && mousePositionYjj[1] >= bottomRightYjj[1];
            // 根据判断结果执行相应操作
            if (isInRectangleYjj) {
              dxq = "宜荆荆都市圈";
              let extent = [...this.arrYijingji[1]];
              this.arrYijingji.forEach((item, index) => {
                extent[0] = Math.min(extent[0], item[0]);
                extent[1] = Math.min(extent[1], item[1]) + 500;
                extent[2] = Math.max(extent[2], item[2]);
                extent[3] = Math.max(extent[3], item[3]) + 1000;
              });
              let allFeatures = [];
              const layers = this.map.getLayers().getArray();
              layers.forEach(layer => {
                if (layer instanceof VectorLayer) {
                  const source = layer.getSource();
                  if (source) {
                    const features = source.getFeatures();
                    allFeatures = allFeatures.concat(features);
                  }
                }
              });
              let features = allFeatures.filter(e => e.values_.level == "city" && (e.values_.name == "恩施土家族苗族自治州" || e.values_.name == "宜昌市" || e.values_.name == "荆门市" || e.values_.name == "荆州市"));
              if (this.formUserId == 1516351940) {
                this.changeShadow1(features, extent, cdata.mapHubeihoverImgDxqXunke[2], "wh");
              } else {
                this.changeShadow1(features, extent, cdata.mapHubeihoverImgDxqJiaohu[2], "wh");
              }
              this.map.getLayers().getArray().forEach(item => {
                if (item.className_ === "hoverimg") {
                  const upextent = extent.map((item, index) => {
                    return index === 1 || index === 3 ? item + 20000 : item;
                  });
                  item.setVisible(true);
                  if (this.formUserId == 1516351940) {
                    item.setSource(new SourceImagestatic({
                      url: cdata.mapHubeihoverImgDxqXunke[2].image,
                      projection: "EPSG:3857",
                      imageExtent: this.hoverLayers.length ? upextent : extent
                    }));
                  } else {
                    item.setSource(new SourceImagestatic({
                      url: cdata.mapHubeihoverImgDxqJiaohu[2].image,
                      projection: "EPSG:3857",
                      imageExtent: this.hoverLayers.length ? upextent : extent
                    }));
                  }
                }
              });
              allfeatures.forEach(e => {
                if (e.getStyle()[1] && e.getStyle()[1].text_.dxq == dxq) {
                  let obj = e.getStyle();
                  // //////////////////////////////////console.log('e1234',obj)
                  e.getStyle()[1].text_.preStyle = obj;
                  // obj[1].text_.fill_ = new StyleFill({ color: "#ffffff" });
                  // obj[1].text_.stroke_ = new StyleStroke({ color: "#045578", width: 2 });
                  obj[1].text_.fill_ = new StyleFill({
                    color: "rgba(54, 68, 217, 1)"
                  });
                  this.changeFontStyle2(e);
                  e.setStyle(obj);
                } else {
                  // e.setStyle(e.getStyle()[1].text_.preStyle)
                }
              });
              // this.createPoint (this.pointlist,null,allfeatures,dxq)
            } else {}

            // if (feature && feature.get("xy")) {
            //   // 获取feature的范围
            //   const extent = feature.getGeometry().getExtent();
            //   const [minX, minY, maxX, maxY] = extent;
            //   //////console.log("extent", extent);
            //   const widthExtension = 10000 * 10;
            //   const heightExtension = 10000;
            //   // 根据范围创建一个填充多边形
            //   const fillPolygonCoords = [
            //     // [minX, minY],
            //     // [maxX, minY],
            //     // [maxX, maxY],
            //     // [minX, maxY],
            //     // [minX, minY],
            //     [minX - widthExtension, minY - heightExtension],
            //     [maxX + widthExtension, minY - heightExtension],
            //     [maxX + widthExtension, maxY + heightExtension],
            //     [minX - widthExtension, maxY + heightExtension],
            //     [minX - widthExtension, minY - heightExtension],
            //   ];
            //   const fillPolygon = new Polygon([fillPolygonCoords]);
            //   const fillFeature = new Feature({ geometry: fillPolygon });
            //   //////console.log("fillPolygonCoords", fillPolygonCoords);
            //   //////console.log("featurexy", feature);
            //   // 设置填充样式为黑色
            //   const fillStyle = new Style({
            //     // fill: new StyleFill({ color: "rgba(235, 243, 255, 1)" }),
            //     fill: new StyleFill({ color: "rgba(235, 243, 255, 1)" }),
            //     image: new StyleCircle({
            //       radius: 16,
            //       // fill: new StyleFill({ color: "rgba(235, 243, 255, 1)" }),
            //       fill: new StyleFill({ color: "rgba(235, 243, 255, 1)" }),
            //     }),
            //   });
            //   fillFeature.setStyle(fillStyle);

            //   // 创建新的矢量数据源用于存放填充多边形
            //   const fillVectorSource = new VectorSource();
            //   fillVectorSource.addFeature(fillFeature);

            //   // 创建矢量图层用于显示填充多边形
            //   const fillVectorLayer = new VectorLayer({
            //     source: fillVectorSource,
            //     zIndex: -1, // 确保填充层在原feature层下方
            //   });

            //   // 将填充图层添加到地图
            //   this.map.addLayer(fillVectorLayer);
            // }
            // if (feature && feature.get("xy")) {
            //   // 获取feature的范围
            //   const extent = feature.getGeometry().getExtent();
            //   const [minX, minY, maxX, maxY] = extent;
            //   //////console.log("extent", extent);
            //   //////console.log("feature", feature);
            //   // let len = feature.values_.name.length + feature.getStyle().length;
            //   const widthExtension = 10000 * 12;
            //   const heightExtension = 12000;
            //   const extraOffset = 30000; // 额外的右偏移量
            //   // 创建一个更大范围的多边形以模拟边框偏移效果
            //   const outerFillPolygonCoords = [
            //     // [minX - widthExtension, minY - heightExtension],
            //     // [maxX + widthExtension, minY - heightExtension],
            //     // [maxX + widthExtension, maxY + heightExtension],
            //     // [minX - widthExtension, maxY + heightExtension],
            //     // [minX - widthExtension, minY - heightExtension],
            //     [minX - widthExtension + extraOffset, minY - heightExtension],
            //     [maxX + widthExtension + extraOffset, minY - heightExtension],
            //     [maxX + widthExtension + extraOffset, maxY + heightExtension],
            //     [minX - widthExtension + extraOffset, maxY + heightExtension],
            //     [minX - widthExtension + extraOffset, minY - heightExtension],
            //   ];
            //   const outerFillPolygon = new Polygon([outerFillPolygonCoords]);
            //   const outerFillFeature = new Feature({ geometry: outerFillPolygon });

            //   // 设置外层填充样式为黑色
            //   const outerFillStyle = new Style({
            //     fill: new StyleFill({ color: "rgba(235, 243, 255, 1)" }), // 半透明黑色
            //     stroke: new StyleStroke({ color: "rgba(235, 243, 255, 1)", width: 2 }), // 边框颜色和宽度
            //   });
            //   outerFillFeature.setStyle(outerFillStyle);

            //   // 创建原始大小的填充多边形
            //   const innerFillPolygonCoords = [
            //     // [minX, minY],
            //     // [maxX, minY],
            //     // [maxX, maxY],
            //     // [minX, maxY],
            //     // [minX, minY],
            //     [minX + extraOffset, minY],
            //     [maxX + extraOffset, minY],
            //     [maxX + extraOffset, maxY],
            //     [minX + extraOffset, maxY],
            //     [minX + extraOffset, minY],
            //   ];
            //   const innerFillPolygon = new Polygon([innerFillPolygonCoords]);
            //   const innerFillFeature = new Feature({ geometry: innerFillPolygon });

            //   // 设置内层填充样式为浅蓝色
            //   const innerFillStyle = new Style({
            //     radius: 24, // 修改后的半径
            //     fill: new StyleFill({ color: "rgba(235, 243, 255, 1)" }),
            //     stroke: new StyleStroke({ color: "blue", width: 2 }), // 边框颜色和宽度
            //   });
            //   innerFillFeature.setStyle(innerFillStyle);

            //   // 创建新的矢量数据源用于存放填充多边形
            //   const fillVectorSource = new VectorSource();
            //   fillVectorSource.addFeatures([outerFillFeature, innerFillFeature]);

            //   // 创建矢量图层用于显示填充多边形
            //   const fillVectorLayer = new VectorLayer({
            //     source: fillVectorSource,
            //     zIndex: -1, // 确保填充层在原feature层下方
            //   });

            //   // 将填充图层添加到地图
            //   this.map.addLayer(fillVectorLayer);
            //   this.boxLayers.push(fillVectorLayer);
            // }

            if (feature && feature.get("xy")) {
              this.changeFontStyle(feature);
              // // 获取feature的范围
              // const extent = feature.getGeometry().getExtent();
              // const [minX, minY, maxX, maxY] = extent;
              // // //////console.log("extent", extent);
              // // //////console.log("feature", feature);
              // // 定义固定的左侧偏移量
              // const fixedLeftOffset = minX + 38000; // 这是所有图层共用的左侧偏移
              // // 定义每个图层的不同宽度扩展
              // const widthExtensions = [
              //   { name: "outer", value: 10000 * 12 },
              //   // { name: "inner", value: 0 }, // 内层不扩展
              // ];
              // let len = feature.values_.name.length + feature.getStyle().length;
              // // 创建并添加所有图层
              // widthExtensions.forEach((extension) => {
              //   const leftX = fixedLeftOffset - extension.value;
              //   const rightX = fixedLeftOffset + (maxX - minX) + 10000 * len;
              //   // 创建一个多边形以模拟边框偏移效果
              //   const fillPolygonCoords = [
              //     [leftX, minY - 12000], // 底部左
              //     [rightX, minY - 12000], // 底部右
              //     [rightX, maxY + 12000], // 顶部右
              //     [leftX, maxY + 12000], // 顶部左
              //     [leftX, minY - 12000], // 关闭路径
              //   ];
              //   const fillPolygon = new Polygon([fillPolygonCoords]);
              //   const fillFeature = new Feature({ geometry: fillPolygon });
              //   // 设置填充样式
              //   const fillStyle = new Style({
              //     fill: new StyleFill({ color: "rgba(235, 243, 255, 1)" }),
              //     stroke: new StyleStroke({
              //       color: "rgba(235, 243, 255, 1)",
              //       width: 2,
              //     }),
              //   });
              //   fillFeature.setStyle(fillStyle);
              //   // 创建新的矢量数据源用于存放填充多边形
              //   const fillVectorSource = new VectorSource();
              //   fillVectorSource.addFeature(fillFeature);
              //   // 创建矢量图层用于显示填充多边形
              //   const fillVectorLayer = new VectorLayer({
              //     source: fillVectorSource,
              //     zIndex: extension.name === "outer" ? -2 : -1, // 确保外层在内层下方
              //   });
              //   // 将填充图层添加到地图并保存引用
              //   this.map.addLayer(fillVectorLayer);
              //   this.boxLayers.push(fillVectorLayer);
              // });
            }
          }
        }
      }
    },
    /**
     * 地图移动结束操作
     */
    markermoveend(evt) {
      sessionStorage.removeItem("currentArea");
      const res = this.map.getView().getResolution();
      // //////////////////////////////////////////////console.log('当前分辨率:', res)
      let zoom = Math.round(this.map.getView().getZoom());
      // //////////////////////////////////////////////console.log('当前zoom:', zoom)
      if (this.defaultZoom === zoom && this.moveendflag) return false;
      if (this.defaultZoom !== zoom) this.defaultZoom = zoom;
      this.$emit("markermoveend", zoom);
      this.map.removeInteraction(this.selectinter);
    },
    changeToolHandle(val) {
      //////////////////////////console.log('changeToolHandle')
      //////////////////////////console.log(val)
      if (val !== "") this.isnotclick = true;
      if (val === 0 || val === 6) {
        this.deleteflag = false;
        this.createHelpTooltip();
        if (val === 0) this.showtexthelp();
      } else {
        if (this.helpTooltipElement) {
          this.helpTooltipElement.innerHTML === "";
          this.helpTooltipElement.classList.add("hidden");
        }
      }
      this.drawtextflag = val === 0 ? true : false;
      this.drawflag = val === 6 ? true : false;
      val === 6 ? this.addDrawInteractions() : this.removedrawInteractions();
      if (val === 2) {
        this.deleteflag = true;
        this.deleteDrawInteractions();
      }
      if (val === 3) {
        this.addselectInteraction();
        this.adddragboxInteraction();
      }
      if (val === 4) this.addtranslateInteraction();
    },
    /**
     * 地图添加 draw snap modify 交互效果
     */
    addDrawInteractions() {
      let that = this;
      this.drawinter = new Draw({
        source: this.drawSource,
        type: "LineString",
        style: this.addStyle()
      });
      this.drawinter.on("drawstart", evt => {
        this.drawsketch = evt.feature;
        let sketch = evt.feature;
        sketch.set("dindex", this.findex);
        this.findex++;
      });
      this.drawinter.on("drawend", evt => {
        this.drawsketch = null;
      });
      this.map.addInteraction(this.drawinter);
      this.modifyinter = new Modify({
        source: this.drawSource,
        style: this.addStyle()
      });
      this.map.addInteraction(this.modifyinter);
      this.snapinter = new Snap({
        source: this.drawSource
      });
      this.map.addInteraction(this.snapinter);
      this.snapinter.on("snap", event => {
        this.helpTooltipElement.innerHTML = "拖动修改";
      });
    },
    getcurrentCoordinates(a1, a2) {
      let x1 = a1[0];
      let y1 = a1[1];
      let x2 = a2[0];
      let y2 = a2[1];
      let newCoordinate = [];
      if (x2 - x1 >= 0 && y2 - y1 >= 0 || x2 - x1 >= 0 && y2 - y1 <= 0 || x2 - x1 <= 0 && y2 - y1 >= 0 || x2 - x1 <= 0 && y2 - y1 <= 0) {
        if (Math.abs(x2 - x1) > Math.abs(y2 - y1)) {
          newCoordinate = [x2, y1];
        } else {
          newCoordinate = [x1, y2];
        }
      }
      return newCoordinate;
    },
    addStyle() {
      return new Style({
        stroke: new StyleStroke({
          color: "#2B67FF",
          width: 2
        }),
        image: new StyleCircle({
          radius: 5,
          fill: new StyleFill({
            color: "#2B67FF"
          })
        })
      });
    },
    /**
     * 地图移出 draw snap modify 交互效果
     */
    removedrawInteractions() {
      this.map.removeInteraction(this.modifyinter);
      this.modifyinter = "";
      this.map.removeInteraction(this.drawinter);
      this.drawinter = "";
      this.map.removeInteraction(this.snapinter);
      this.snapinter = "";
      this.map.removeInteraction(this.selectinter);
      this.selectinter = "";
      this.map.removeInteraction(this.dragboxinter);
      this.dragboxinter = "";
      this.map.removeInteraction(this.translateinter);
      this.translateinter = "";
    },
    /**
     * 创建提示信息
     */
    createHelpTooltip() {
      if (this.helpTooltipElement) this.helpTooltipElement.parentNode.removeChild(this.helpTooltipElement);
      this.helpTooltipElement = document.createElement("div");
      this.helpTooltipElement.className = "ol-tooltip hidden";
      this.helpTooltip = new Overlay({
        element: this.helpTooltipElement,
        offset: [15, 0],
        positioning: "center-left"
      });
      this.map.addOverlay(this.helpTooltip);
    },
    /**
     * 绘制删除操作
     */
    deleteDrawInteractions() {
      if (this.selectedFeatures.length === 0) {
        ElMessage({
          message: "请先选择要删除的绘制元素",
          type: "warning"
        });
        return;
      }
      let deletedata = [];
      ElMessageBox.confirm("确定要删除么？", "温馨提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
        this.selectedFeatures.getArray().forEach(feature => {
          if (feature.get("name")) deletedata.push({
            key: feature.get("id"),
            label: feature.get("name")
          });
          this.SET_MAPDRAWLAYERITEM({
            deleteList: deletedata
          });
          this.drawSource.removeFeature(feature);
        });
      }).catch(() => {
        this.selectedFeatures.clear();
      });
    },
    addselectInteraction() {
      // let flag=true
      // let fea=''
      this.selectinter = new Select({
        style: feature => {
          //////////////////////////console.log('1111')
          // fea=feature
          // if(feature.getStyle().length>=2){
          //   //////////////////////////console.log(2)
          // }else{
          //   //////////////////////////console.log(1)
          //   //////////////////////////console.log(feature)

          //   //////////////////////////console.log(feature.getStyle())

          // }
          let selectStyle = feature.getStyle();
          let score = feature.get("score");
          let type = feature.get("type");
          //////////////////console.log('score',score)
          //////////////////console.log('type',type)
          if (score === 0) {
            selectStyle = [new Style({
              image: new StyleIcon({
                src: feature.get("image"),
                anchor: [1.3, 0.5],
                scale: 0.05
              })
            }),
            // 这里是高亮效果
            new Style({
              text: new StyleText({
                textAlign: "left",
                text: feature.get("name"),
                font: `14px sans-serif`,
                offsetY: 1,
                // offsetX: -30,
                fill: new StyleFill({
                  color: "#ffffff"
                }),
                stroke: new StyleStroke({
                  color: "#045578",
                  width: 2
                })
              })
            })];
          }
          if (type === "areapolygon") {
            // selectStyle = [new Style({
            //   fill: new StyleFill({ color: 'rgba(255, 255, 255, 0.4)' }),
            //   stroke: new StyleStroke({
            //     color: '#045578',
            //     width: 2,
            //     lineDash: [6, 4]
            //   })
            // })]
            selectStyle = [new Style({
              fill: new StyleFill({
                color: "rgba(255, 255, 255, 0)"
              }),
              stroke: new StyleStroke({
                color: "rgba(255, 255, 255, 0)",
                width: 2
                // lineDash: [6, 4]
              })
            })];
          }
          if (type === "areaicon") {
            selectStyle = [new Style({
              image: new StyleIcon({
                src: require("@/assets/map/138053/circle.png"),
                scale: 1.8
              })
            })];
          }
          return selectStyle;
        }
      });
      // this.map.addInteraction(this.selectinter)
      this.map.removeInteraction(this.selectinter);
      let that = this;
      this.selectinter.on("select", function (evt) {
        if (that.selectinter.getFeatures().getArray().length === 0) {
          that.removeModify();
          that.removeTranslate();
        } else {
          let type = that.selectinter.getFeatures().getArray()[0].get("type");
          let dragId = that.selectinter.getFeatures().getArray()[0].get("id");
          //////////////////console.log('type',type)
          //////////////////console.log('dragId',dragId)

          if (type && type.includes("area")) {
            /** 选中当前区域列表、ICON、LINE  **/
            //////////////////////////////console.log('that.areaList',that.areaList)
            let selectItem = that.onlyAreaList(that.areaList).find(item => {
              return item.id === dragId;
            });
            //////////////////////////////console.log('selectItem',selectItem)
            ////////////////////////////////console.log('that.onlyAreaList(that.areaList)',that.onlyAreaList(that.areaList))
            ////////////////////////////////console.log('dragId',dragId)

            that.setSelectData(selectItem);
            that.adddrawSourceTranslate();
          } else {
            let selectItem;
            if (that.jsonOption.drawlayer && that.jsonOption.drawlayer.drawarea.length) {} else {
              that.onlyAreaList(that.areaList).forEach(item => {
                if (item.data.length > 0) {
                  item.data.forEach(elem => {
                    if (elem === dragId) selectItem = item;
                  });
                }
              });
            }

            //////////////////console.log(`selectItem`, selectItem);
            if (selectItem) that.setSelectData(selectItem);
            that.addiconSourceModify(selectItem);
          }
        }
      });
    },
    removeModify() {
      this.map.removeInteraction(this.modifyinter);
      this.modifyinter = "";
    },
    removeTranslate() {
      this.map.removeInteraction(this.translateinter);
      this.translateinter = "";
    },
    // 点击后，鼠标划过出现点
    addiconSourceModify(item) {
      //////////////////console.log('item',item)
      /* item值为undefined 说明areaList无该点位数据 */
      let that = this;
      this.modifyinter = new Modify({
        source: this.iconSource,
        style: this.addStyle()
      });
      //////////////////////////////////////////////console.log(this.addStyle())
      this.map.addInteraction(this.modifyinter);
      this.modifyinter.on("modifystart", function (evt) {});
      this.modifyinter.on("modifyend", function (evt) {
        //////////////////console.log('evt.features',evt.features)
        let coodrs = evt.features.getArray()[0].getGeometry().getCoordinates();
        //////////////////console.log('coodrs',coodrs)
        let isExistpolygon;

        // 这里是判断点位是否拖动到了框框内
        that.drawSource.getFeatures().forEach(feature => {
          if (feature.get("type") === "areapolygon") {
            ////////////////////console.log('进框areapolygon')
            //////////////////console.log('feature',feature)

            let extent = feature.getGeometry().getExtent();
            //////////////////console.log('extent',extent)
            //////////////////console.log(coodrs[0] <= extent[2])
            //////////////////console.log(coodrs[0] >= extent[0])
            //////////////////console.log(coodrs[1] <= extent[3])
            //////////////////console.log(coodrs[1] >= extent[1])
            if (coodrs[0] <= extent[2] && coodrs[0] >= extent[0] && coodrs[1] <= extent[3] && coodrs[1] >= extent[1]) {
              isExistpolygon = feature;
            }
          }
        });
        //////////////////console.log('isExistpolygon',isExistpolygon)
        //////////////////console.log('item',item)
        /* 新增点 */
        if (isExistpolygon !== undefined && item == undefined) {
          let dragId = isExistpolygon.get("id");
          let areaIndex = that.onlyAreaList(that.areaList).findIndex(item => {
            return item.id === dragId;
          });
          //////////////////console.log('dragId',dragId)
          //////////////////console.log('areaIndex',areaIndex)

          that.setSelectData(that.onlyAreaList(that.areaList)[areaIndex]);
          that.polygonchangefeature(evt.features.getArray()[0], 0, areaIndex);
          that.onlyAreaList(that.areaList)[areaIndex].data.push(evt.features.getArray()[0].get("id"));
        }
        /* 删除点 */
        if (isExistpolygon === undefined && item !== undefined) {
          let areaIndex, dataIndex;
          that.onlyAreaList(that.areaList).forEach((item, index) => {
            item.data.forEach((elem, eIndex) => {
              if (elem === evt.features.getArray()[0].get("id")) {
                areaIndex = index;
                dataIndex = eIndex;
              }
            });
          });
          //////////////////console.log('areaIndex',areaIndex)
          //////////////////console.log('dataIndex',dataIndex)
          ////////////////////console.log('evt.features',evt.features)
          ////////////////////console.log('evt.features.getArray()',evt.features.getArray())
          ////////////////////console.log('evt.features.getArray()[0]',evt.features.getArray()[0])
          ////////////////////console.log('evt.features.getArray()[0]12',that.areaList)
          ////////////////////console.log('that.selectArr',that.selectArr)
          // that.iconSource.removeFeature(that.iconSource.getFeatures().find(e=>e.get('id')=='1542133933'))
          that.polygonchangefeature(evt.features.getArray()[0], 1, areaIndex);
          if (that.selectArr.length > 0) that.onlyAreaList(that.areaList)[areaIndex].data.splice(dataIndex, 1);
        }
      });
    },
    /**
     * 区域列表新增或删除点位操作 type 0新增  1删除
     */
    polygonchangefeature(feature, type, areaIndex) {
      if (type === 0) this.selectArr.push(feature);
      ////////////////////console.log('this.selectArr.push(feature)',this.selectArr.push(feature))
      if (type === 1) {
        let index = this.selectArr.findIndex(item => item.get("id") === feature.get("id"));
        this.selectArr.splice(index, 1);
        feature.getGeometry().setCoordinates(transform(feature.get("xy"), "EPSG:4326", "EPSG:3857"));
      }
      this.selectinter.getFeatures().clear();
      this.removeModify();
      /** 区域列表内无点位数据操作,这里可以做初始化时候，线段的删除操作 **/
      if (this.selectArr.length === 0) {
        let boxid = this.onlyAreaList(this.areaList)[areaIndex].id;
        this.drawSource.getFeatures().forEach(feature => {
          if (feature.get("id") === boxid) this.drawSource.removeFeature(feature);
        });
        this.onlyAreaList(this.areaList).splice(areaIndex, 1);
      } else {
        let center = this.pointIcon.getGeometry().getCoordinates();
        this.setpointCoordinates(center, type);
        this.polygonfeature.setGeometry(new Polygon([this.getPolygonCoords()]));
        this.onlyAreaList(this.areaList)[areaIndex].datafirstcenter = this.selectArr[0].getGeometry().getCoordinates();
        this.onlyAreaList(this.areaList)[areaIndex].iconcenter = this.pointIcon.getGeometry().getCoordinates();
      }
    },
    // 点击按钮后，清除所有区域列表内的数据
    onClickClearAll(areaindex) {
      ////////////////////console.log('areaindex',areaindex)
      ////////////////////console.log('this.selectArr',this.selectArr)
      ////////////////////console.log('this.selectArr.length',this.selectArr.length)
      ////////////////////console.log('this.currentSelectData',this.currentSelectData)
      if (this.selectArr.length) {
        // let showDelArr=[]
        this.onlyAreaList(this.areaList)[areaindex].data.forEach((e, idx) => {
          let index = this.selectArr.findIndex(item => item.get("id") * 1 == e);
          let feature = this.iconSource.getFeatures().find(o => o.get("id") * 1 == e);
          let id;
          this.drawSource.getFeatures().forEach(fea => {
            if (fea.get("type") === "areaicon") {
              ////////////////////console.log('areaicon')
            }
          });
          // let isExist=this.currentSelectData.data.find(e=>e==this.selectArr[0].get('id'))
          // ////////////////////console.log('isExist',isExist)

          // if(this.currentSelectData.length){
          //   // ////////////////////console.log('this.currentSelectData.length')
          //   // ////////////////////console.log(this.currentSelectData)
          //     this.drawSource.getFeatures().forEach(fea => {
          //   if (fea.get('type') === 'areaicon'){
          //     if(fea.get('id')==this.currentSelectData[0].id){
          //       this.drawSource.removeFeature(fea)
          //     }
          //   }
          // })
          // }

          // ////////////////////console.log('index',index)
          ////////////////////console.log('feature',feature)
          let ids = this.drawelement.drawarea.filter(o => o.data.includes(this.selectArr[0].values_.id));
          ////////////////////console.log('ids',ids)
          if (ids.length) {
            ids.forEach(x1 => {
              this.drawSource.getFeatures().forEach(fea => {
                if (fea.get("type") === "areaicon") {
                  if (fea.get("id") == x1.id) {
                    ////////////////////console.log('find')
                    ////////////////////console.log(fea)
                    this.drawSource.removeFeature(fea);
                  }
                }
                if (fea.get("type") === "arealine") {
                  if (fea.get("id") == x1.id) {
                    ////////////////////console.log('find')
                    ////////////////////console.log(fea)
                    this.drawSource.removeFeature(fea);
                  }
                }
                if (fea.get("type") === "areapolygon") {
                  if (fea.get("id") == x1.id) {
                    ////////////////////console.log('find')
                    ////////////////////console.log(fea)
                    this.drawSource.removeFeature(fea);
                  }
                }
              });
            });
          }
          // ////////////////////console.log('index',index)
          ////////////////////console.log('feature2',feature)
          // this.selectArr.splice(index, 1)
          ////////////////////console.log('this.drawelement.drawarea',this.drawelement.drawarea)

          feature.getGeometry().setCoordinates(transform(feature.get("xy"), "EPSG:4326", "EPSG:3857"));
          // ////////////////////console.log('index',index)
          // this.drawSource.getFeatures().forEach(fea => {
          //   if (fea.get('type') === 'areaicon'&&fea.get('id')==31){
          //    ////////////////////console.log('areaicon')
          //    ////////////////////console.log(fea)
          //   }
          // })
          // ////////////////////console.log('feature',feature)
        });
      } else {
        this.onlyAreaList(this.areaList)[areaindex].data.forEach((e, idx) => {
          // let index  = this.selectArr.findIndex(item => item.get('id')*1 ==e )
          let feature = this.iconSource.getFeatures().find(o => o.get("id") * 1 == e);
          let x1 = this.drawelement.drawarea.find(o => o.data.includes(feature.get("id")));
          ////////////////////console.log('x1',x1)
          // ////////////////////console.log('index',index)
          ////////////////////console.log('feature2',feature)
          // this.selectArr.splice(index, 1)
          feature.getGeometry().setCoordinates(transform(feature.get("xy"), "EPSG:4326", "EPSG:3857"));
          // ////////////////////console.log('index',index)
          ////////////////////console.log('feature3',feature)
        });
      }
      ////////////////////console.log('this.onlyAreaList(this.areaList)[areaindex]',this.onlyAreaList(this.areaList)[areaindex])
    },
    setSelectData(select) {
      if (select == undefined) return;
      this.selectArr = [];
      ////////////////////console.log('setSelectData')
      ////////////////////console.log(select)
      this.currentSelectData = select;

      //   ////////////////////console.log('this.currentSelectData.length')
      //   ////////////////////console.log(this.currentSelectData)
      //     this.drawSource.getFeatures().forEach(fea => {
      //   if (fea.get('type') === 'areaicon'){
      //     if(fea.get('id')==this.currentSelectData.id){
      //       this.drawSource.removeFeature(fea)
      //     }
      //   }
      // })

      select.data.forEach(item => {
        this.iconSource.getFeatures().forEach(feature => {
          if (item === feature.get("id")) this.selectArr.push(feature);
        });
      });
      this.drawSource.getFeatures().forEach(feature => {
        //////////////////////console.log('areapolygon',feature)
        if (feature.get("id") === select.id) {
          if (feature.get("type") === "areaicon") this.pointIcon = feature;
          if (feature.get("type") === "areapolygon") this.polygonfeature = feature;
          if (feature.get("type") === "arealine") this.linefeature = feature;
        }
      });
    },
    // addselectInteraction () {
    //   this.selectinter = new Select({
    //     style: (feature) => {
    //       let featuretype = feature.getGeometry().getType()
    //       if (featuretype !== 'LineString' && featuretype !== 'Point' && featuretype !== 'Circle') return
    //       let textstyle = this.currentTextstyle
    //       if (feature.get('name')) textstyle = feature.get('style')
    //       return new Style({
    //         fill: new StyleFill({ color: '#2B67FF' }),
    //         stroke: new StyleStroke({
    //           color: '#2B67FF', width: feature.get('type') === 'circle' ? this.CircleRadius : 2
    //         }),
    //         text: feature.get('name') ? new StyleText({
    //           text: textstyle.align === 0 ? feature.get('name').split('').join('\n') : feature.get('name'),
    //           font: `${textstyle.fontSize}px FZShengShiKaiShuS-DB-GB`,
    //           textBaseline: 'top',
    //           textAlign: 'left',
    //           fill: new StyleFill({color: '#2B67FF'})
    //         }) : ''
    //       })
    //     }
    //   })

    //   this.map.addInteraction(this.selectinter)
    //   this.selectedFeatures = this.selectinter.getFeatures()
    // },
    /**
     * 选择绘制元素
     */
    // addselectInteraction () {
    //   this.selectinter = new Select({
    //     style: (feature) => {
    //       let featuretype = feature.getGeometry().getType()
    //       if (featuretype !== 'LineString' && featuretype !== 'Point' && featuretype !== 'Circle') return
    //       let textstyle = this.currentTextstyle
    //       if (feature.get('name')) textstyle = feature.get('style')
    //       return new Style({
    //         fill: new StyleFill({ color: '#2B67FF' }),
    //         stroke: new StyleStroke({
    //           color: '#2B67FF', width: feature.get('type') === 'circle' ? this.CircleRadius : 2
    //         }),
    //         text: feature.get('name') ? new StyleText({
    //           text: textstyle.align === 0 ? feature.get('name').split('').join('\n') : feature.get('name'),
    //           font: `${textstyle.fontSize}px FZShengShiKaiShuS-DB-GB`,
    //           textBaseline: 'top',
    //           textAlign: 'left',
    //           fill: new StyleFill({color: '#2B67FF'})
    //         }) : ''
    //       })
    //     }
    //   })

    //   this.map.addInteraction(this.selectinter)
    //   this.selectedFeatures = this.selectinter.getFeatures()
    // },
    /**
     *
     * 框选绘制元素
     */
    // adddragboxInteraction () {
    //   this.dragboxinter = new DragBox({
    //     condition: platformModifierKeyOnly,
    //   })
    //   this.dragboxinter.on('boxstart', () => {
    //     this.selectedFeatures.clear()
    //   })
    //   this.dragboxinter.on('boxend', () => {
    //     const boxExtent = this.dragboxinter.getGeometry().getExtent()
    //     const worldExtent = this.map.getView().getProjection().getExtent()
    //     const worldWidth = getWidth(worldExtent)
    //     const startWorld = Math.floor((boxExtent[0] - worldExtent[0]) / worldWidth)
    //     const endWorld = Math.floor((boxExtent[2] - worldExtent[0]) / worldWidth)
    //     for (let world = startWorld; world <= endWorld; ++world) {
    //       const left = Math.max(boxExtent[0] - world * worldWidth, worldExtent[0])
    //       const right = Math.min(boxExtent[2] - world * worldWidth, worldExtent[2])
    //       const extent = [left, boxExtent[1], right, boxExtent[3]]
    //       const boxFeatures = this.drawSource.getFeaturesInExtent(extent).filter((feature) =>
    //         !this.selectedFeatures.getArray().includes(feature) &&
    //         feature.getGeometry().intersectsExtent(extent),
    //       )
    //       const rotation = this.map.getView().getRotation()
    //       const oblique = rotation % (Math.PI / 2) !== 0
    //       if (oblique) {
    //         const anchor = [0, 0]
    //         const geometry = this.dragboxinter.getGeometry().clone()
    //         geometry.translate(-world * worldWidth, 0)
    //         geometry.rotate(-rotation, anchor)
    //         const extent = geometry.getExtent()
    //         boxFeatures.forEach(function (feature) {
    //           const geometry = feature.getGeometry().clone()
    //           geometry.rotate(-rotation, anchor)
    //           if (geometry.intersectsExtent(extent)) {
    //             this.selectedFeatures.push(feature)
    //           }
    //         })
    //       } else {
    //         this.selectedFeatures.extend(boxFeatures)
    //       }
    //     }
    //     let that = this

    //   })
    //   this.map.addInteraction(this.dragboxinter)
    // },
    /**
     * 平移绘制元素
     */
    drawAreaList(val) {
      //////////////////////////////console.log(' this.drawelement.drawarea')
      //////////////////////////////console.log( this.drawelement.drawarea)
      // ////////console.log("val", val);
      // 存在点位区域列表数据
      if (Object.keys(this.drawelement).length > 0 && this.drawelement.drawarea) {
        if (this.iseditpoint) this.$emit("drawarea", true);
        this.viewratio = this.map.getView().getResolution();
        this.map.getLayers().getArray().forEach(item => {
          //////////////////////////////////////////////console.log('item',item)
          if (item.className_ === "icon") item.setZIndex(7);
          if (item.className_ === "draw") item.setZIndex(6);
        });
        ////////console.log("this.drawelement.drawarea", this.drawelement.drawarea);
        //////////////////////////////////////////////console.log(`this.drawelement.drawarea`, this.drawelement.drawarea)
        this.drawelement.drawarea.forEach(area => {
          //////////////////////////////console.log('area',area)
          this.pointIcon = new Feature({
            geometry: new Point(area.iconcenter),
            id: area.id,
            type: "areaicon"
          });
          this.pointIcon.setStyle(new Style({
            image: new StyleIcon({
              src: require("@/assets/map/138053/circle.png"),
              // opacity:this.formUserId==1514653091?0:1
              // src: 'https://p.ananas.chaoxing.com/star3/origin/93f06f6eaf18f318ce99392322d2309d.png',
              opacity: 0
            })
          }));
          this.drawSource.addFeature(this.pointIcon);
          console.log("area", area);
          let features = [];
          let slen = features.length;
          let px = area.datafirstcenter[0];
          let py = area.datafirstcenter[1] - 10000;
          this.increase = this.viewratio * this.ih;
          this.transdiffx = area.datafirstcenter[0] - area.iconcenter[0];
          if (area.data.length == 5 && area.iconcenter.length && area.iconcenter[1] > 3200000 && area.iconcenter[1] < 3400000) {
            area.data.forEach((elem, index) => {
              this.iconSource.getFeatures().forEach(feature => {
                if (elem === feature.get("id")) {
                  let len = feature.get("name").length;
                  this.nmaxlen = this.nmaxlen <= len ? len : this.nmaxlen;
                  feature.getGeometry().setCoordinates([px, py + -index * this.increase - 40000]);
                  features.push(feature);
                }
              });
            });
          } else if (area.data.length == 3) {
            if (area.iconcenter[0] < 12100000 && area.iconcenter[0] >= 12070000) {
              area.data.forEach((elem, index) => {
                this.iconSource.getFeatures().forEach(feature => {
                  // //////console.log("feature", feature);
                  if (elem === feature.get("id")) {
                    let len = feature.get("name").length;
                    this.nmaxlen = this.nmaxlen <= len ? len : this.nmaxlen;
                    feature.getGeometry().setCoordinates([px, py + -index * this.increase
                    // py + (index !== 0 ? -index * this.increase : 0),
                    ]);
                    features.push(feature);
                  }
                });
              });
            } else {
              area.data.forEach((elem, index) => {
                this.iconSource.getFeatures().forEach(feature => {
                  // //////console.log("feature", feature);
                  if (elem === feature.get("id")) {
                    let len = feature.get("name").length;
                    this.nmaxlen = this.nmaxlen <= len ? len : this.nmaxlen;
                    feature.getGeometry().setCoordinates([px, py + -index * this.increase - 37000
                    // py + (index !== 0 ? -index * this.increase : 0),
                    ]);
                    features.push(feature);
                  }
                });
              });
            }
          } else if (area.data.length == 11) {
            area.data.forEach((elem, index) => {
              this.iconSource.getFeatures().forEach(feature => {
                // //////console.log("feature", feature);
                if (elem === feature.get("id")) {
                  let len = feature.get("name").length;
                  this.nmaxlen = this.nmaxlen <= len ? len : this.nmaxlen;
                  feature.getGeometry().setCoordinates([px - 50000, py + -index * this.increase + 5000
                  // py + (index !== 0 ? -index * this.increase : 0),
                  ]);
                  features.push(feature);
                }
              });
            });
          } else if (area.data.length == 1) {
            // console.log("1", area);
            if (area.iconcenter[0] < 12750000 && area.iconcenter[0] >= 12720000) {
              area.data.forEach((elem, index) => {
                this.iconSource.getFeatures().forEach(feature => {
                  // //////console.log("feature", feature);
                  if (elem === feature.get("id")) {
                    let len = feature.get("name").length;
                    this.nmaxlen = this.nmaxlen <= len ? len : this.nmaxlen;
                    feature.getGeometry().setCoordinates([px, py + -index * this.increase + 5000
                    // py + (index !== 0 ? -index * this.increase : 0),
                    ]);
                    features.push(feature);
                  }
                });
              });
            } else {
              area.data.forEach((elem, index) => {
                this.iconSource.getFeatures().forEach(feature => {
                  // //////console.log("feature", feature);
                  if (elem === feature.get("id")) {
                    let len = feature.get("name").length;
                    this.nmaxlen = this.nmaxlen <= len ? len : this.nmaxlen;
                    feature.getGeometry().setCoordinates([px, py + -index * this.increase - 10000
                    // py + (index !== 0 ? -index * this.increase : 0),
                    ]);
                    features.push(feature);
                  }
                });
              });
            }
          } else if (area.data.length == 2) {
            console.log("2", area);
            if (area.iconcenter[0] < 11700000 && area.iconcenter[0] >= 11696971) {
              area.data.forEach((elem, index) => {
                this.iconSource.getFeatures().forEach(feature => {
                  // //////console.log("feature", feature);
                  if (elem === feature.get("id")) {
                    let len = feature.get("name").length;
                    this.nmaxlen = this.nmaxlen <= len ? len : this.nmaxlen;
                    feature.getGeometry().setCoordinates([px + 25000, py + (index !== 0 ? -index * this.increase : 0)
                    // py + (index !== 0 ? -index * this.increase : 0),
                    ]);
                    features.push(feature);
                  }
                });
              });
            } else {
              area.data.forEach((elem, index) => {
                this.iconSource.getFeatures().forEach(feature => {
                  // //////console.log("feature", feature);
                  if (elem === feature.get("id")) {
                    let len = feature.get("name").length;
                    this.nmaxlen = this.nmaxlen <= len ? len : this.nmaxlen;
                    feature.getGeometry().setCoordinates([px, py + (index !== 0 ? -index * this.increase : 0)]);
                    features.push(feature);
                  }
                });
              });
            }
          } else {
            area.data.forEach((elem, index) => {
              this.iconSource.getFeatures().forEach(feature => {
                // //////console.log("feature", feature);
                if (elem === feature.get("id")) {
                  let len = feature.get("name").length;
                  this.nmaxlen = this.nmaxlen <= len ? len : this.nmaxlen;
                  feature.getGeometry().setCoordinates([px, py + (index !== 0 ? -index * this.increase : 0)]);
                  features.push(feature);
                }
              });
            });
          }
          let polygonextent = this.setpolyonextent(features);
          // //////console.log("polygonextent", polygonextent);
          this.polygonfeature = new Feature({
            geometry: new Polygon([this.extentToPolygonCoords(polygonextent)]),
            id: area.id,
            type: "areapolygon"
          });
          this.polygonfeature.setStyle(new Style({
            fill: new StyleFill({
              color: "rgba(0, 0, 0,0 )"
            }),
            stroke: new StyleStroke({
              color: "rgba(0, 0, 0, 0)",
              width: 1
            })
          }));
          // this.polygonfeature.setStyle(
          //   new Style({
          //     fill: new StyleFill({ color: "rgba(0, 0, 0, 1)" }),
          //     // stroke: new StyleStroke({
          //     //   color: "rgba(0, 0, 0, 1)",
          //     //   width: 1,
          //     // }),
          //   })
          // );
          this.drawSource.addFeature(this.polygonfeature);
          /** 判断line在pointIcon 左侧(false)或右侧(true) **/
          let direction = polygonextent[0] > area.iconcenter[0];
          let polygonwidth = polygonextent[2] - polygonextent[0];
          this.linefeature = new Feature({
            geometry: new LineString([area.iconcenter, [polygonextent[0] + (direction ? 0 : polygonwidth), area.iconcenter[1]]]),
            id: area.id,
            type: "arealine"
          });
          //   this.linefeature.setStyle(new Style({
          //     stroke: new StyleStroke({
          //   // color: 'rgba(0,0,0,0)',
          //   // width: 4,
          //   // lineDash: [6, 4]
          //   color: 'rgba(0, 56, 238, 0.35)',
          //   width: 4,
          //   // lineDash: [6, 4]
          // })
          //   }))
          if (this.formUserId == 1514653091) {
            this.linefeature.setStyle(new Style({
              stroke: new StyleStroke({
                color: "rgba(0,0,0,0)",
                width: 4,
                lineDash: [6, 4]
                // color: 'rgba(0, 56, 238, 0.35)',
                // width: 4,
              })
            }));
          } else {
            this.linefeature.setStyle(new Style({
              stroke: new StyleStroke({
                color: "rgba(0,0,0,0)",
                width: 4,
                lineDash: [6, 4]
                // color: 'rgba(0, 56, 238, 0.35)',
                // width: 4,
              })
            }));
          }
          this.drawSource.addFeature(this.linefeature);
        });
        this.areaList = this.drawelement.drawarea;
        // //////////////////////////////////console.log(this.drawelement.drawarea)
      }
    },
    adddragboxInteraction() {
      this.dragboxinter = new DragBox({
        condition: platformModifierKeyOnly
      });
      this.map.addInteraction(this.dragboxinter);
      this.dragboxinter.on("boxstart", () => {
        this.selectedFeatures = [];
      });
      this.dragboxinter.on("boxend", () => {
        const boxExtent = this.dragboxinter.getGeometry().getExtent();
        const worldExtent = this.map.getView().getProjection().getExtent();
        const worldWidth = getWidth(worldExtent);
        const startWorld = Math.floor((boxExtent[0] - worldExtent[0]) / worldWidth);
        const endWorld = Math.floor((boxExtent[2] - worldExtent[0]) / worldWidth);
        for (let world = startWorld; world <= endWorld; ++world) {
          const left = Math.max(boxExtent[0] - world * worldWidth, worldExtent[0]);
          const right = Math.min(boxExtent[2] - world * worldWidth, worldExtent[2]);
          const extent = [left, boxExtent[1], right, boxExtent[3]];
          const boxFeatures = this.iconSource.getFeaturesInExtent(extent).filter(feature => feature.getGeometry().intersectsExtent(extent));
          this.selectedFeatures = boxFeatures;
        }
        let that = this;
        ////////////////////////////////console.log('this.selectedFeatures',this.selectedFeatures)
        this.resetAreaParams();
        if (this.jsonOption.drawlayer && this.jsonOption.drawlayer.drawarea.length) {
          this.boxId = this.jsonOption.drawlayer.drawarea.length + 1;
        } else {
          this.boxId++;
        }
        ////////////////////////////////console.log('this.boxId')
        ////////////////////////////////console.log(this.boxId)
        this.editareaList(this.selectedFeatures);
        this.$emit("drawarea", true);
        if (this.formUserId !== 1514653091) {
          this.dialogVisible = true;
        }
      });
    },
    adddrawSourceTranslate() {
      let that = this;
      this.translateinter = new Translate({
        features: this.selectinter.getFeatures()
      });
      this.map.addInteraction(this.translateinter);

      /** 拖拽列表区域控制在ICON左侧或右侧  拖拽ICON 整体随之改变位置  **/
      let startCoords, startpolygonCoords, startlineCoords, polygonwidth, startSelectArr, starticonCoords, dragelemtype, dragelemgId;
      this.translateinter.on("translatestart", function (evt) {
        ////////////////////////////////console.log(`translatestart`, evt);
        dragelemtype = evt.features.getArray()[0].get("type");
        // dragelemgId = evt.features.getArray()[0].get('id')
        dragelemgId = evt.features.getArray()[0].get("id");
        startCoords = evt.startCoordinate;
        starticonCoords = that.pointIcon.getGeometry().getCoordinates();
        startpolygonCoords = that.polygonfeature.getGeometry().getCoordinates();
        startlineCoords = that.linefeature.getGeometry().getCoordinates();
        polygonwidth = startpolygonCoords[0][1][0] - startpolygonCoords[0][0][0];
        startSelectArr = _.cloneDeep(that.selectArr);
        // //////////////////////////////console.log('dragelemtype',dragelemtype)
        // //////////////////////////////console.log('dragelemgId',dragelemgId)
        // //////////////////////////////console.log('startCoords',startCoords)
        // //////////////////////////////console.log('starticonCoords',starticonCoords)
        // //////////////////////////////console.log('startpolygonCoords',startpolygonCoords)
        // //////////////////////////////console.log('startlineCoords',startlineCoords)
        // //////////////////////////////console.log('polygonwidth',polygonwidth)
        // //////////////////////////////console.log('startSelectArr',startSelectArr)
      });
      this.translateinter.on("translating", function (evt) {
        that.transdiffx = evt.coordinate[0] - startCoords[0];
        that.transdiffy = evt.coordinate[1] - startCoords[1];
        let translatepolygonCoords = startpolygonCoords[0].map(item => {
          return [item[0] + that.transdiffx, item[1] + (dragelemtype === "areaicon" ? that.transdiffy : 0)];
        });
        that.polygonfeature.setGeometry(new Polygon([translatepolygonCoords]));
        ////////////////////////////////console.log('translating')
        ////////////////////////////////console.log(startpolygonCoords)
        ////////////////////////////////console.log(translatepolygonCoords)
        that.selectArr.forEach((elem, index) => {
          let select = startSelectArr[index].getGeometry().getCoordinates();
          elem.getGeometry().setCoordinates([select[0] + that.transdiffx, select[1] + (dragelemtype === "areaicon" ? that.transdiffy : 0)]);
        });

        /** 判断polygon在pointIcon 左侧(false)或右侧(true) **/
        let direction = evt.coordinate[0] > startlineCoords[0][0];
        let translatelineCoords;
        if (dragelemtype === "areaicon") {
          translatelineCoords = startlineCoords.map((item, index) => {
            return [item[0] + that.transdiffx, item[1] + that.transdiffy];
          });
          ////////////////////////////////console.log('areaicon')
          ////////////////////////////////console.log(startlineCoords)
        } else {
          ////////////////////////////////console.log('startlineCoords')
          ////////////////////////////////console.log(startlineCoords)
          translatelineCoords = startlineCoords.map((item, index) => {
            if (index === 1) item = [translatepolygonCoords[1][0] - (direction ? polygonwidth : 0), item[1]];
            return item;
          });
        }
        that.linefeature.setGeometry(new LineString(translatelineCoords));
      });
      this.translateinter.on("translateend", function (evt) {
        // ////////////////////////////////console.log(789)
        // ////////////////////////////////console.log(that.areaList)
        let areaIndex = that.areaList.findIndex(item => {
          return item.id === dragelemgId;
        });
        if (that.areaList[areaIndex] != undefined) {
          that.areaList[areaIndex].datafirstcenter = that.selectArr[0].getGeometry().getCoordinates();
          that.areaList[areaIndex].iconcenter = that.pointIcon.getGeometry().getCoordinates();
        }

        // ////////////////////////////////console.log('dragelemgId')
        // ////////////////////////////////console.log(dragelemgId)
        // ////////////////////////////////console.log('that.areaList[areaIndex].datafirstcenter')
        // ////////////////////////////////console.log(that.areaList[areaIndex].datafirstcenter)
        // ////////////////////////////////console.log('that.areaList[areaIndex].iconcenter')
        // ////////////////////////////////console.log(that.areaList[areaIndex].iconcenter)
      });
    },
    editareaList(val) {
      ////////////////////console.log('val',val)
      if (val.length == 0) return;
      this.viewratio = this.map.getView().getResolution();
      this.map.getLayers().getArray().forEach(item => {
        if (item.className_ === "icon") item.setZIndex(7);
        if (item.className_ === "draw") item.setZIndex(6);
      });
      this.selectArr = val;
      let extent = boundingExtent(this.selectArr.map(feature => feature.getGeometry().getCoordinates()));
      ////////////////////////////////console.log('extent')
      ////////////////////////////////console.log(extent)
      ////////////////////////////////console.log('this.selectArr')
      ////////////////////////////////console.log(this.selectArr)
      let center = getCenter(extent);
      // 隐藏掉圆圈
      this.pointIcon = new Feature({
        geometry: new Point(center),
        id: this.boxId,
        type: "areaicon"
      });
      this.pointIcon.setStyle(new Style({
        image: new StyleIcon({
          src: require("@/assets/map/138053/circle.png"),
          opacity: this.formUserId == 1514653091 ? 0 : 1
        })
      }));
      this.drawSource.addFeature(this.pointIcon);
      this.drift = this.viewratio * 300;
      this.increase = this.viewratio * this.ih;
      this.setpointCoordinates(center);

      // 隐藏掉边框

      this.polygonfeature = new Feature({
        geometry: new Polygon([this.getPolygonCoords()]),
        id: this.boxId,
        type: "areapolygon"
      });
      this.polygonfeature.setStyle(new Style({
        fill: new StyleFill({
          color: "rgba(0, 0, 0, 0)"
        }),
        stroke: new StyleStroke({
          color: "rgba(0, 0, 0, 0)",
          width: 1
        })
      }));
      // this.polygonfeature.setStyle(new Style({
      //   fill: new StyleFill({ color: 'rgba(255, 255, 255, 1)' }),
      //   stroke: new StyleStroke({
      //     color: 'rgba(255, 255, 255, 1)',
      //     width: 1,
      //   })
      // }))
      this.drawSource.addFeature(this.polygonfeature);
      // 隐藏掉线
      this.linefeature = new Feature({
        geometry: new LineString([center, [center[0] + this.drift - this.viewratio * 34 * 3, center[1]]]),
        id: this.boxId,
        type: "arealine"
      });
      if (this.formUserId == 1514653091) {
        this.linefeature.setStyle(new Style({
          stroke: new StyleStroke({
            color: "rgba(0,0,0,0)",
            width: 4,
            lineDash: [6, 4]
          })
        }));
      } else {
        this.linefeature.setStyle(new Style({
          stroke: new StyleStroke({
            color: "rgba(0, 56, 238, 0.35)",
            width: 4
          })
        }));
      }
      this.drawSource.addFeature(this.linefeature);
      let dataId = this.selectArr.map(item => {
        return item.get("id");
      });
      this.areaList.push({
        id: this.boxId,
        iconcenter: center,
        data: dataId,
        datafirstcenter: this.selectArr[0].getGeometry().getCoordinates()
      });
    },
    setpointCoordinates(center, type) {
      let slen = this.selectArr.length;
      let px = center[0];
      let py = Math.abs(center[1] + this.viewratio * this.ih * (slen - 1) / 2);
      this.selectArr.forEach((elem, index) => {
        let len = elem.get("name").length;
        this.nmaxlen = this.nmaxlen <= len ? len : this.nmaxlen;
        let coords = elem.getGeometry().getCoordinates();
        let x = px + this.drift;
        if (this.transdiffx !== 0) {
          x = coords[0];
          if (type === 0 && index === slen - 1) x = this.selectArr[0].getGeometry().getCoordinates()[0];
        }
        elem.getGeometry().setCoordinates([x, py + (index !== 0 ? -index * this.increase : 0)]);
      });
    },
    getPolygonCoords() {
      return this.extentToPolygonCoords(this.setpolyonextent(this.selectArr));
    },
    setpolyonextent(features) {
      ////////////////////////////////console.log('setpolyonextent')
      ////////////////////////////////console.log(features)
      ////////////////////////////////console.log(features.map(feature => feature.getGeometry().getCoordinates()))
      let polygonextent = boundingExtent(features.map(feature => feature.getGeometry().getCoordinates()));
      ////////////////////////////////console.log(polygonextent)
      polygonextent[0] = polygonextent[0] - this.viewratio * 34;
      polygonextent[1] = polygonextent[1] - this.viewratio * 18;
      polygonextent[2] = polygonextent[2] + this.nmaxlen * 12 * this.viewratio;
      polygonextent[3] = polygonextent[3] + this.viewratio * 18;
      return polygonextent;
    },
    extentToPolygonCoords(extent) {
      return [[extent[0], extent[1]],
      // 左上角
      [extent[2], extent[1]],
      // 右上角
      [extent[2], extent[3]],
      // 右下角
      [extent[0], extent[3]],
      // 左下角
      [extent[0], extent[1]] // 闭合
      ];
    },
    resetAreaParams() {
      this.pointIcon = "";
      this.polygonfeature = "";
      this.linefeature = "";
      this.nmaxlen = 0;
      this.drift = 0;
      this.increase = 0;
      this.transdiffx = 0;
      this.transdiffy = 0;
    },
    addtranslateInteraction() {
      if (this.selectedFeatures.length === 0) {
        ElMessage({
          message: "请先选择要平移的绘制元素",
          type: "warning"
        });
        return;
      }
      this.translateinter = new Translate({
        features: this.selectedFeatures
      });
      this.map.addInteraction(this.translateinter);
    },
    /**
     * 绘制文字
     */
    createText(val, name) {
      //////////////////////////////////////////////console.log(`绘制文字`, val)
      this.drawSource.getFeatures().forEach(feature => {
        if (feature.get("type") === 0) this.drawSource.removeFeature(feature);
      });
      let data = this.mapv2info.drawlayer;
      let iconFeatures = [];
      let list = name === "currentList" ? val : data.currentList;
      list.forEach((elem, index) => {
        let coordinate = [...data.currentCoordinate];
        let cstyle = {
          ...this.currentTextstyle
        };
        cstyle.color = (index - 1) % 3 === 0 ? cstyle.color2 : cstyle.color1;
        let space = cstyle.fontSpace ? cstyle.fontSpace : 4;
        if (cstyle.align === 0) coordinate[0] = coordinate[0] + index * (cstyle.fontSize * space * 0.001);
        if (cstyle.align === 1) coordinate[1] = coordinate[1] - index * (cstyle.fontSize * space * 0.001);
        let feature = new Feature({
          geometry: new Point(transform(coordinate, "EPSG:4326", "EPSG:3857")),
          id: elem.key,
          name: elem.label,
          type: name === "currentList" ? 0 : val,
          style: cstyle
        });
        let text = elem.label;
        if (cstyle.align === 0) {
          elem.label = elem.label.replace(/\uff08/g, "\ufe35");
          elem.label = elem.label.replace(/\uff09/g, "\ufe36");
          text = elem.label.split("").join("\n");
        }
        feature.setStyle(new Style({
          text: new StyleText({
            text: text,
            font: `${cstyle.fontSize}px FZShengShiKaiShuS-DB-GB`,
            textBaseline: "top",
            textAlign: "left",
            fill: new StyleFill({
              color: cstyle.color
            })
          })
        }));
        iconFeatures.push(feature);
      });
      this.drawSource.addFeatures(iconFeatures);
      if (name === "drawtextblocksum") {
        this.SET_MAPDRAWLAYERITEM({
          currentList: []
        });
        this.showtexthelp();
      }
    },
    showtexthelp() {
      this.drawtextsingleflag = false;
      this.helpTooltipElement.innerHTML = "点击选择位置后 添加点位名称";
      this.helpTooltipElement.classList.remove("hidden");
    },
    /**
     * 保存绘制数据
     */
    saveDrawHandle() {
      let feature = this.drawSource.getFeatures();
      let jsonObj = new GeoJSON().writeFeatures(feature);
      this.SET_MAPDRAWLAYERITEM({
        drawJson: feature.length > 0 ? jsonObj : ""
      });
    },
    /**
     * 创建非遗数据点位
     */
    createculturalPoint(val) {
      if (val.length === 0) return;
      let showArr = val.filter(item => {
        return item.itemformdata.correlation_map === "是" && item.itemformdata.correlation_address.length > 0;
      });
      showArr.forEach(elem => {
        let item = elem.itemformdata;
        // 有坐标的显示
        let gd = bd_decrypt(Number(item.correlation_address[0].lng), Number(item.correlation_address[0].lat));
        let x = Number(gd.lng);
        let y = Number(gd.lat);
        let obj = {
          name: item.title,
          image: item.icon ? item.icon : this.defaulticon,
          icon: ""
        };
        let pointfeature = new Feature({
          geometry: new Point(fromLonLat([x, y])),
          id: elem.id,
          name: obj.name,
          image: obj.image,
          icon: "",
          xy: [x, y],
          score: 0
        });
        pointfeature.setStyle(this.getStyle(obj, 1));
        this.iconSource.addFeature(pointfeature);
      });
      // 龙岩地图添加 随机显示 gif动图 20240529 后面可以在高级设置的 交互效果 做统一对接
      if (this.$route.query.fid === "138053") {
        this.setpointlight(showArr);
      }
    },
    setpointlight(arr) {
      let that = this;
      let len = arr.length;
      let max = len / 3;
      let newIndexArr = [];
      for (let i = 0; i < 6; i++) {
        let randIndex = Math.floor(Math.random() * len);
        if (!newIndexArr.includes(randIndex)) newIndexArr.push(randIndex);
      }
      newIndexArr.forEach(elem => {
        let item = arr[elem].itemformdata;
        // 有坐标的显示
        let gd = bd_decrypt(Number(item.correlation_address[0].lng), Number(item.correlation_address[0].lat));
        let x = Number(gd.lng);
        let y = Number(gd.lat);
        let obj = {
          name: item.title,
          image: this.lightIcon[Math.floor(Math.random() * 3)],
          icon: "",
          gif: this.lightIcon[Math.floor(Math.random() * 3)]
        };
        let pointfeature = new Feature({
          geometry: new Point(fromLonLat([x, y])),
          id: arr[elem].id,
          name: obj.name,
          image: obj.image,
          icon: "",
          xy: [x, y],
          // score: 1,
          score: 0,
          light: true
        });
        const gifUrl = obj.gif;
        const gif = gifler(gifUrl);
        gif.frames(document.createElement("canvas"), function (ctx, frame) {
          if (!pointfeature.getStyle()) {
            pointfeature.setStyle(new Style({
              image: new StyleIcon({
                img: ctx.canvas,
                opacity: 1,
                imgSize: [frame.width, frame.height],
                anchor: [0.5, 0.5],
                scale: 0.02
              })
            }));
          }
          ctx.clearRect(0, 0, frame.width, frame.height);
          ctx.drawImage(frame.buffer, frame.x, frame.y);
          that.map.render();
        }, true);
        this.iconSource.addFeature(pointfeature);
      });
    },
    addpopOverLay(coordinate) {
      const container = document.querySelector(".popcontainer-style1");
      this.overlay = new Overlay({
        element: container,
        positioning: "bottom-left"
      });
      this.overlay.setPosition(fromLonLat(coordinate));
      this.map.addOverlay(this.overlay);
    },
    removeAlliconsource() {
      this.iconSource.clear();
    },
    removeDrawsource() {
      this.drawSource.clear();
    },
    removeRoutesource() {
      this.routeSource.clear();
    },
    createRoute(val) {
      ////////////////////////////////console.log(`createRoute`, val)
      if (val.length === 0) return;
      this.routeSource.clear();
      let routeFeatures = [];
      this.allpath = [];
      this.routeData = _.cloneDeep(val);
      val.forEach((item, index) => {
        let linestyle = {
          ...item.style
        };
        if (linestyle.lineDash) {
          linestyle.lineDash.length > 0 ? linestyle.lineDash = linestyle.lineDash.map(item => {
            return linestyle.width * item;
          }) : delete linestyle.lineDash;
        }
        if (index === 0) this.routeStyle = linestyle;
        item.path.forEach((child, cdi) => {
          let gemoetry = new LineString(child);
          if (item.routelinetype === 3 && child.length > 2) {
            this.curverouteCoords[cdi] = child.slice(1, -1);
            gemoetry = new LineString(createBezierCurvePoints(child.length - 1, child));
          }
          let routeFeature = new Feature({
            id: item.id ? item.id : cdi,
            type: "allroute",
            geometry: gemoetry
          });
          routeFeature.setStyle(new Style({
            stroke: new StyleStroke(linestyle)
          }));
          routeFeatures.push(routeFeature);
          let itemcoords = gemoetry.getCoordinates();
          if (gemoetry.getCoordinates().length === 2) itemcoords = getPointsBetweenLatLong(itemcoords[0][1], itemcoords[0][0], itemcoords[1][1], itemcoords[1][0], 100);
          this.allpath.push(...itemcoords);
        });
      });
      this.saveCurverouteCoords(false);
      this.routeSource.addFeatures(routeFeatures);

      // 若线段的类型 是曲线且配置页打开时 开启绘制曲线功能
      if (val[0].isCurve) {
        //////////////////////////////////////////////console.log(`开启绘制曲线功能`);
        this.addCurveselectInteraction();
      }
      this.startMove();
      // 移动端显示路线后 路线的初始经纬度挪到地图的中心点 防止看不到
      if (this.isMobile && val.length === 1) this.map.getView().animate({
        center: val[0].path[0][0]
      });
    },
    startMove() {
      this.geoMarker = new Feature({
        type: "geoMarker",
        geometry: new Point(this.allpath[0])
      });
      this.geoMarker.setStyle(new Style({
        // 设置标记样式
        image: new StyleIcon({
          anchor: [0.5, 1],
          // 偏移位置
          src: this.moveicon,
          rotateWithView: true,
          opacity: 0
        })
      }));
      this.routeSource.addFeature(this.geoMarker);
      this.nowDate = new Date().getTime();
      this.animating = true;
      this.routeLayer.on("postrender", this.moveFeature);
      this.map.render();
    },
    moveFeature(event) {
      let vectorContext = olRender.getVectorContext(event);
      let frameState = event.frameState;
      let speed = this.allpath.length / 4;
      if (this.animating) {
        let elapsedTime = frameState.time - this.nowDate;
        let index = Math.round(speed * elapsedTime / 1000);
        // 进度条
        this.moveprogress = Math.floor(100 / this.allpath.length * (speed * elapsedTime) / 1000);
        if (index >= this.allpath.length) {
          this.moveprogress = "100";
          this.stopMove(true);
          return;
        }
        let currentPoint = new Point(this.allpath[index]);
        let feature = new Feature(currentPoint);
        vectorContext.drawFeature(feature, new Style({
          // 设置标记样式
          image: new StyleIcon({
            anchor: [0.5, 1],
            // 偏移位置
            src: this.moveicon,
            rotateWithView: true
          })
        }));
      }
      // tell OpenLayers to continue the postrender animation
      this.map.render();
    },
    stopMove(ended) {
      this.moveprogress = 0;
      this.animating = false;
      let coord = ended ? this.allpath[this.allpath.length - 1] : this.allpath[0];
      this.geoMarker.getGeometry().setCoordinates(coord);
      //remove listener
      this.routeLayer.un("postrender", this.moveFeature); // 删除侦听器
    },
    loadLocation(val) {
      this.locationSource.clear();
      if (Object.keys(val).length > 0 && val.lng && val.lat) {
        let gd = bd_decrypt(val.lng, val.lat);
        let feature = new Feature({
          geometry: new Point(fromLonLat([gd.lng, gd.lat])),
          id: 1,
          type: "location"
        });
        feature.setStyle(new Style({
          image: new StyleIcon({
            src: this.locationicon,
            anchor: [0.5, 0.5],
            scale: 0.7,
            rotateWithView: true
          })
        }));
        this.locationSource.addFeature(feature);
      }
    },
    /**
     * 路线曲线 选择绘制元素
     */
    addCurveselectInteraction() {
      let that = this;
      this.map.getInteractions().getArray().forEach(interaction => {
        if (interaction instanceof Select) this.map.removeInteraction(interaction);
      });
      this.selectinter = new Select({
        layers: [this.routeLayer],
        condition: click,
        style: feature => {
          let featuretype = feature.getGeometry().getType();
          if (featuretype !== "LineString" && featuretype !== "Point" && featuretype !== "Circle") return;
          return new Style({
            stroke: new StyleStroke({
              lineDash: [3, 6],
              color: "rgba(0, 0, 255, 1)",
              width: 3
            })
          });
        }
      });
      this.map.addInteraction(this.selectinter);
      this.selectinter.on("select", function (evt) {
        // //////////////////////////////////////////////console.log('select');
        // //////////////////////////////////////////////console.log(evt);
        // //////////////////////////////////////////////console.log(`that.routeData`, that.routeData);
        // //////////////////////////////////////////////console.log(`that.selectIndex`, that.selectIndex);
        // //////////////////////////////////////////////console.log(`that.routeStyle`, that.routeStyle);

        // 选择后未点击取消或确定按钮 触发事件
        if (that.curvetools !== null && that.curvetools !== undefined && that.selectIndex !== "") {
          that.routeSource.getFeatures().forEach(feature => {
            if (evt.selected.length > 0 && feature.get("id") === evt.selected[0].get("id")) feature.setStyle(new Style({
              stroke: new StyleStroke(that.routeStyle)
            }));
            if (feature.get("id") === that.selectIndex) that.selectinter.getFeatures().push(feature);
          });
          return;
        }
        if (that.selectinter.getFeatures().getArray().length === 0) {
          that.removeCurveModify();
          that.saveCurverouteCoords(false);
        } else {
          // 判断曲线下path 个数 若个数大于2 代表曲线
          that.modifySource = new VectorSource();
          let fIndex = evt.selected[0].get("id");
          if (that.routeData[0].path[fIndex].length > 2) {
            that.selectIndex = fIndex;
            let spath = that.routeData[0].path[fIndex];
            let scurvepath = createBezierCurvePoints(spath.length - 1, spath);
            evt.selected[0].setGeometry(new LineString(spath));
            that.modifySource.addFeature(evt.selected[0]);
            let curveFeature = new Feature({
              id: 999,
              type: "curve",
              geometry: new LineString(scurvepath)
            });
            curveFeature.setStyle(new Style({
              stroke: new StyleStroke(that.routeStyle)
            }));
            that.routeSource.addFeature(curveFeature);
            let extent = evt.selected[0].getGeometry().getExtent();
            let curvetoolsDom = document.getElementById("curvetools");
            curvetoolsDom.classList.add("show");
            that.curvetools = new Overlay({
              position: [extent[2], extent[3]],
              element: document.getElementById("curvetools")
            });
            that.map.addOverlay(that.curvetools);
          } else {
            that.modifySource.addFeature(that.selectinter.getFeatures().getArray()[0]);
          }
          that.addCurvemodifyInteraction();
          that.saveCurverouteCoords(true);
        }
      });
    },
    /**
     * 路线曲线 修改绘制元素
     */
    addCurvemodifyInteraction() {
      let that = this;
      this.modifyinter = new Modify({
        source: this.modifySource,
        style: this.addStyle()
      });
      this.map.addInteraction(this.modifyinter);
      this.modifyinter.on("modifyend", evt => {
        let select = that.selectinter.getFeatures().getArray();
        select.forEach(feature => {
          that.selectIndex = feature.get("id");
          that.selectCoords = feature.getGeometry().getCoordinates();
          let n = that.selectCoords.length - 1;
          that.selectcurveCoords = createBezierCurvePoints(n, that.selectCoords);
          let extent = feature.getGeometry().getExtent();
          let curvetoolsDom = document.getElementById("curvetools");
          curvetoolsDom.classList.add("show");
          that.curvetools = new Overlay({
            position: [extent[2], extent[3]],
            element: document.getElementById("curvetools")
          });
          that.map.addOverlay(that.curvetools);
          that.routeSource.getFeatures().forEach(item => {
            if (item.get("type") === "curve") {
              item.setGeometry(new LineString(that.selectcurveCoords));
            } else {
              let curveFeature = new Feature({
                id: 999,
                type: "curve",
                geometry: new LineString(that.selectcurveCoords)
              });
              curveFeature.setStyle(new Style({
                stroke: new StyleStroke(that.routeStyle)
              }));
              that.routeSource.addFeature(curveFeature);
            }
          });
        });
      });
    },
    /** 移除修改交互 **/
    removeCurveModify() {
      this.modifySource = "";
      this.map.removeInteraction(this.modifyinter);
      this.modifyinter = "";
    },
    /** 曲线重置直线 **/
    resetrouteLine() {
      //////////////////////////////////////////////console.log(`this.selectIndex`, this.selectIndex);
      let coords = this.routeData[0].path.filter((item, index) => {
        return index === this.selectIndex;
      });
      let linecoords = [coords[0][0], coords[0][coords[0].length - 1]];
      this.routeData[0].path[this.selectIndex] = linecoords;
      this.resetroutefeature(linecoords);
      this.curverouteCoords[this.selectIndex] = null;
      this.saveCurverouteCoords(false);
      this.resetCurveSelectParams();
    },
    /** 曲线确认操作 **/
    confirmrouteLine() {
      let selectFeature = this.selectinter.getFeatures().getArray()[0];
      let selectFeatureIndex = selectFeature.get("id");
      let selectFeatureCoords = selectFeature.getGeometry().getCoordinates();
      //////////////////////////////////////////////console.log(`selectFeatureIndex`, selectFeatureIndex);
      //////////////////////////////////////////////console.log(`selectFeatureCoords`, selectFeatureCoords);
      this.routeData[0].path[selectFeatureIndex] = selectFeatureCoords;
      let coords = selectFeatureCoords.slice(1, -1);
      //////////////////////////////////////////////console.log(`coords`, coords);
      //////////////////////////////////////////////console.log(`this.routeData`, this.routeData);
      this.curverouteCoords[selectFeatureIndex] = coords;
      this.saveCurverouteCoords(false);
      this.resetroutefeature(this.selectcurveCoords);
      this.resetCurveSelectParams();
    },
    /** 路线曲线 重置参数及方法(公共) **/
    resetCurveSelectParams() {
      this.curvetools.setPosition(undefined);
      this.selectinter.getFeatures().clear();
      this.removeCurveModify();
      this.selectCoords = [];
      this.selectIndex = "";
      this.selectcurveCoords = [];
      this.curvetools = null;
    },
    resetroutefeature(coords) {
      this.routeSource.getFeatures().forEach(feature => {
        if (feature.get("id") === this.selectIndex) {
          feature.setGeometry(new LineString(coords));
          feature.setStyle(new Style({
            stroke: new StyleStroke(this.routeStyle)
          }));
        }
        if (feature.get("type") === "curve") this.routeSource.removeFeature(feature);
      });
    },
    saveCurverouteCoords(flag) {
      ////////////////////////////////console.log('saveCurverouteCoords')
      ////////////////////////////////console.log(this.curverouteCoords)
      this.SET_MAPROUTECURVE({
        switch: flag,
        data: this.curverouteCoords.map(item => {
          return item !== null ? item.map(child => {
            return transform(child, "EPSG:3857", "EPSG:4326");
          }) : item;
        })
      });
    },
    getmapPixelFromCoordinate(val) {
      //////////////////////////////////////////////console.log(`val`, val);
      let iconarr = this.iconSource.getFeatures();
      for (let index = 0; index < iconarr.length; index++) {
        const feature = iconarr[index];
        if (val.id === feature.get("id")) return this.map.getPixelFromCoordinate(feature.getGeometry().getCoordinates());
      }
    }
  }
};